<template>
    <v-container grid-list-md fluid>
        <!--  ** first titles row -->
        <v-row class="d-flex justify-space-between mb-1">
            <!-- ** back button + title -->
            <v-col cols="6">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11">
                        <h2>
                            Reprise des immobilisations et amortissements antérieurs
                            <v-tooltip location:q="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-icon color="secondary" v-bind="props" class="ml-2">
                                        $oss-help
                                    </v-icon>
                                </template>

                                <h4>Actions effectuées :</h4>
                                <h4>
                                    Contre-passation des reports à nouveaux des comptes
                                    d'immobilisations et d'amortissements
                                </h4>
                                <h4>Création des lignes d'immobilisations détaillées</h4>
                                <h4>
                                    Génération des tableaux d'amortissements complets, conformément
                                    à la situation au 31/12/N-1
                                </h4>
                                <h4>Comptabilisation des dotations mensuelles encore à courir</h4>
                            </v-tooltip>
                        </h2>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <!-- ** Lier un document -->
                    <!-- ** upload -->
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** Message -->
                    <!-- ** chat -->
                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="storeComments()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="validationDisabled"
                        @click="
                            validated = !validated;
                            storeComments();
                        "
                        data-cy="CheckFixedAssetsCutPrevious-valid"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                storeComments('REVIEW');
                            "
                        />
                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                storeComments('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>

                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>

                            <template v-if="!showDeleteAcrBtnIfRecovery">
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <div no-gutters v-bind="props">
                                            <v-list-item no-gutters disabled>
                                                <v-list-item-title>
                                                    Supprimer la reprise
                                                </v-list-item-title>

                                                <template v-slot:append>
                                                    <v-icon size="small"> $oss-trash </v-icon>
                                                </template>
                                            </v-list-item>
                                        </div>
                                    </template>
                                    <span>{{ showDeleteAcrBtnTooltipMessage }}</span>
                                </v-tooltip>
                            </template>

                            <!-- ** without tooltip -->
                            <template v-else>
                                <v-list-item
                                    no-gutters
                                    @click="deleteAuditCheckResultDialog = true"
                                >
                                    <v-list-item-title> Supprimer la reprise </v-list-item-title>

                                    <template v-slot:append>
                                        <v-icon>$oss-trash</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>

        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >  
            <!-- ** loading -->
            <template v-if="loading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <!-- ** recoveryFinished -->
            <template v-else-if="recoveryFinished && results && results[0] && results[0].date">

                <v-card-title class="pl-14 pr-0 py-2">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <h3 style="color: #e1be7a">
                                Reprise des amortissements 'avant bobbee' effectuée le
                                {{ formatDate(results[0].date) }}
                            </h3>
                        </v-col>
                    </v-row>
                </v-card-title>

                <!-- ** import errorsUploadDocument -->
                <template v-if="errorsUploadDocument.size">
                    <div
                         class="pb-0 pe-3 d-inline-block"
                    >
                        <span 
                            v-for="[key, value] in errorsUploadDocument"
                            :key="key"
                            class="pb-0 d-inline-block">
                            <h4 class="ms-14 py-0 text-primary">
                                {{ $t("audit.cutPrevious." + key) }}
                            </h4>
                            <v-row no-gutters class="ms-14">
                                <v-col cols="12" v-for="(fixedAssetWording, index) in value" :key="index" >
                                    - {{ fixedAssetWording }}
                                </v-col>    
                            </v-row>
                        </span>
                    </div>
                    <h4
                        class="pb-0 ms-14 text-error"
                    >
                        Vous pouvez corriger les imports de documents en supprimant la reprise et en
                        la recréant après avoir corriger les soucis.
                        Ou en ajoutant les documents manquants manuellement.
                    </h4>
                </template>
            </template>

            <!-- ** currentPeriodIsFirstPeriod -->
            <template v-else-if="currentPeriodIsFirstPeriod">
                <v-row no-gutters>
                    <v-col cols="8">
                        <h3 style="color: #e1be7a" class="pt-2 pl-2">
                            Premier exercice d'activité : pas de reprise d'immobilisations
                        </h3>
                    </v-col>
                </v-row>
            </template>

            <!-- ** N accountingPeriod.closed && !noData -->
            <template v-else-if="noData">
                <v-row no-gutters>
                    <v-col>
                        <h3 style="color: #e1be7a" class="pt-2 pl-2">Aucune donnée</h3>
                    </v-col>
                </v-row>
            </template>

            <!-- ** N accountingPeriod.closed -->
            <!-- <template v-else-if="accountingPeriod && accountingPeriod.closed && (!fixedAssetsFile || !fixedAssetsFile.length)"> -->
            <template v-else-if="closedPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée, aucune action possible</h3>
                </v-row>
            </template>

            <!-- ** recovery not finished && no existing N-1  -->
            <template
                v-else-if="!recoveryFinished && (!N_1AccountingPeriod || !N_1AccountingPeriod.id)"
            >
                <v-row no-gutters>
                    <v-col cols="12" style="color: #e1be7a">
                        <h3>Attention : pas d'exercice N-1, aucune action possible</h3>
                    </v-col>

                    <v-col cols="12">
                        <h3 style="color: #e1be7a">
                            S'il existe, pour le créer et clôturer : Mon dossier - Exercices -
                            Ajouter (attention à cocher "exercice clôturé)
                        </h3>
                    </v-col>
                </v-row>
            </template>

            <!-- ** recovery not finished && N-1 not closed -->
            <template
                v-else-if="!recoveryFinished && N_1AccountingPeriod && !N_1AccountingPeriod.closed"
            >
                <v-row no-gutters style="color: #e1be7a">
                    <v-col cols="1" />
                    <v-col cols="10">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <h3>Attention : N-1 n'est pas clôturé, aucune action possible</h3>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col cols="12">
                                <h3>
                                    Pour clôturer Mon dossier - Exercices - N-1 - Modifier -
                                    Exercice clôturé
                                </h3>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </template>

            <!-- ** no company first period -->
            <template v-else-if="!companyFirstPeriod.start">
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10" class="d-flex justify-center mt-5">
                        <h3 class="text-primary">
                            Afin de calculer correctement toutes les reprises il est nécessaire de
                            renseigner dans "Mon dossier" - "Entreprise" - "Régimes d'imposition"
                            les dates de début d'activité et de fin du premier exercice d'activité
                        </h3>
                    </v-col>
                    <v-col cols="1" />
                </v-row>
            </template>

            <!-- ** good template -->
            <template v-else-if="accountingPeriod">
                <!-- ** N open && N-1 closed  -->
                <!-- ** allways showed message -->
                <v-card-subtitle class="px-0 pt-2 pb-4">
                    <h3 class="px-14 text-primary">
                        Attention : la reprise automatique est actuellement fonctionnelle avec les
                        amortissements linéaires uniquement
                    </h3>
                </v-card-subtitle>

                <v-card-title class="pl-14 pr-0 py-2">
                    <v-row no-gutters class="d-flex align-center">
                        <v-col cols="auto">
                            <h3 class="pt-2">
                                Tableau d'amortissements à reprendre au
                                {{ formatDate(selectedDate) }}
                            </h3>
                        </v-col>

                        <v-spacer />

                        <!-- ++ ALL BUTTONS -->
                        <v-col cols="auto" class="px-4">
                            <!-- ** someDecliningDepreciationError -->
                            <v-btn-warning
                                v-if="someDecliningDepreciationError"
                                size="x-small"
                                color="red"
                                @click="someDecliningDepreciationErrorDialog = true"
                            >
                            </v-btn-warning>

                            <!-- ** gap : change accountable Account -->
                            <!-- ** fixed assets || Depreciation || Derogation  -->
                            <v-btn-warning
                                v-if="
                                    changeFixedAssetsAccountableAccountGap ||
                                    changeDepreciationAccountableAccountGap ||
                                    changeDerogationAccountableAccountGap
                                "
                                size="x-small"
                                color="red"
                                @click="changeAccountableAccountsGapsDialog = true"
                            >
                            </v-btn-warning>

                            <!-- ** fullDepreciatedFixedAssetsDialog -->
                            <v-btn-warning
                                v-if="
                                    errorsOnFullDepreciatedFixedAssets &&
                                    errorsOnFullDepreciatedFixedAssets.length
                                "
                                size="x-small"
                                color="red"
                                @click="fullDepreciatedFixedAssetsDialog = true"
                            >
                            </v-btn-warning>

                            <!-- ** fullGapsDialog -->
                            <v-btn-warning
                                v-else-if="gapToAffect"
                                size="x-small"
                                color="red"
                                @click="fullGapsDialog = true"
                            >
                            </v-btn-warning>

                            <!-- ** gap68OnRegulN_1Errors -->
                            <v-btn-warning
                                v-else-if="gap68LOnRegulN_1Errors && gap68LOnRegulN_1Errors.length"
                                size="x-small"
                                color="red"
                                @click="gap68LOnRegulN_1ErrorsDialog = true"
                            >
                            </v-btn-warning>

                            <!-- ** Import -->
                            <!-- ** !fixedAssetsFile -->
                            <!-- ** OR -->
                            <!-- ** fixedAssetsFile -->
                            <!-- ** gaps > import -->
                            <v-btn
                                v-if="importConditions"
                                :loading="
                                    importLoading || storeFixedAssetsLoading || storeCutsLoading
                                "
                                @click="importFunction()"
                                size="small"
                                data-cy="CheckFixedAssetsCutPrevious-importer"
                            >
                                Importer
                            </v-btn>

                            <!-- ** alsToCut > cutPrevious -->
                            <v-btn v-else-if="cutConditions" size="small" @click="cutPrevious()">
                                Découper les reports à nouveau
                                <v-icon icon="$cut" />
                            </v-btn>

                            <!-- ** als2ToDepreciate > alsToDepreciateLoop -->
                            <v-btn
                                v-else-if="depreciateConditions"
                                :loading="alsToDepreciateLoopLoading"
                                size="small"
                                @click="alsToDepreciateLoop()"
                            >
                                Générer les tableaux d'amortissements et les écritures

                                <template v-slot:loader>
                                    <v-progress-linear
                                        rounded
                                        color="white"
                                        class="mx-2"
                                        height="18"
                                        :model-value="
                                            (100 * alIndex) / (als2ToDepreciateLength - 1)
                                        "
                                    >
                                        <template v-slot:default>
                                            <strong class="text-secondary">
                                                {{ alIndex }} / {{ als2ToDepreciateLength }}
                                            </strong>
                                        </template>
                                    </v-progress-linear>
                                </template>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>

                <!-- ** import errorMessages -->
                <template v-if="errorMessages.length">
                    <v-card-title
                        v-for="(errorMessage, index) in errorMessages"
                        :key="index"
                        class="pb-0"
                    >
                        <h4 class="px-14 py-0" style="color: #e1be7a">
                            {{ errorMessage }}
                        </h4>
                    </v-card-title>
                </template>

                <!-- ++ ERROR DIALOGS -->
                <!-- ** v-card-title: gap error message -->
                <!-- ** import errorMessages -->

                <template v-else-if="fixedAssetsFile && fixedAssetsFile.length">
                    <!-- ++ someTypeD or some145AccountableAccount -->
                    <oss-dialog
                        v-if="someDecliningDepreciationError"
                        v-model="someDecliningDepreciationErrorDialog"
                        withoutHeader="true"
                        @close="closeDialog()"
                        min-width="90vw"
                    >
                        <v-alert border="start" border-color="red" class="py-0 mb-0">
                            <div v-html="someDecliningDepreciationErrorMessage" />
                        </v-alert>
                    </oss-dialog>

                    <template v-if="!isEmpty(gaps) || gap68LOnRegulN_1ErrorsDialog">
                        <!-- ++ CHANGE ACCOUNTABLE ACCOUNTS GAPS DIALOG -->
                        <oss-dialog
                            v-if="
                                !someDecliningDepreciationError &&
                                (changeFixedAssetsAccountableAccountGap ||
                                    changeDepreciationAccountableAccountGap ||
                                    changeDerogationAccountableAccountGap)
                            "
                            v-model="changeAccountableAccountsGapsDialog"
                            withoutHeader="true"
                            max-height="100%"
                            :validDisabled="disabledChangeFixedAssetsAccountableAccountGap"
                            :validTitle="'Valider la modification des comptes comptables'"
                            @close="changeAccountableAccountsGapsDialog = false"
                            @valid="storeAccountableAccountsChanges()"
                            min-width="100vw"
                        >
                            <v-window v-model="changeAccountableAccountsGapStep">
                                <!-- ** changeAccountableAccountsGapStep 1 -->
                                <v-window-item :value="'changeAAList'">
                                    <template v-if="changeFixedAssetsAccountableAccountGap">
                                        <div class="pl-2 pr-4">
                                            <h2 class="pb-2">
                                                Aucun écart global sur les COMPTES D'IMMOBILISATION,
                                                il suffit de modifier les comptes comptables
                                            </h2>

                                            <v-row
                                                no-gutters
                                                v-if="gap_fixedAssetsAccountableAccount"
                                            >
                                                <v-col cols="4" class="d-flex align-center">
                                                    <h4>Ecarts sur le grand livre :</h4>
                                                </v-col>

                                                <v-col cols="8">
                                                    <oss-data-table
                                                        :headers="gapsGlHeaders"
                                                        :items="
                                                            gap_fixedAssetsAccountableAccount
                                                                .gapData.glWithoutImportResume
                                                        "
                                                        :striped="true"
                                                        :x-dense="true"
                                                        class="table"
                                                    >
                                                        <template v-slot:item="props">
                                                            <tr>
                                                                <td
                                                                    :class="
                                                                        'text-left ' +
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{ props.item.aaName || "" }}
                                                                </td>

                                                                <td
                                                                    :class="
                                                                        'text-right ' +
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item.glSum,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td
                                                                    :class="
                                                                        'text-right ' +
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item
                                                                                .alreadyImportedSum,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td
                                                                    :class="
                                                                        'text-right ' +
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item.importedSum,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td
                                                                    :class="
                                                                        'text-right ' +
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item.gap,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </template>

                                                        <template v-slot:body.append>
                                                            <tr class="x-dense">
                                                                <th class="text-start">Totaux</th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "glSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "alreadyImportedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "importedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "gap",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>
                                                            </tr>
                                                        </template>
                                                    </oss-data-table>
                                                </v-col>
                                            </v-row>

                                            <v-row
                                                no-gutters
                                                v-if="gap_fixedAssetsAccountableAccount"
                                                class="pt-4 pb-2"
                                            >
                                                <v-col
                                                    v-if="
                                                        gap_fixedAssetsAccountableAccount.gapData &&
                                                        !gap_fixedAssetsAccountableAccount.gapData
                                                            .sumGap
                                                    "
                                                >
                                                    <h3 class="py-2">
                                                        Détails des immobilisations importées dont
                                                        les comptes comptables ne trouvent pas de
                                                        correspondance dans le grand livre :
                                                    </h3>
                                                </v-col>
                                            </v-row>
                                        </div>

                                        <oss-data-table
                                            :headers="gapsImportedLinesHeaders2"
                                            :items="
                                                gap_fixedAssetsAccountableAccount.gapData
                                                    .importLinesWithoutGl
                                            "
                                            :striped="true"
                                            :x-dense="true"
                                            :virtual-scroll="true"
                                            class="table"
                                        >
                                            <template v-slot:item="props">
                                                <tr>
                                                    <td
                                                        class="text-left"
                                                        :style="
                                                            gapSelectColor(
                                                                props.item,
                                                                'aaNameFixedAsset',
                                                            )
                                                        "
                                                    >
                                                        {{ props.item.aaNameFixedAsset || "" }}
                                                    </td>

                                                    <td
                                                        class="text-left"
                                                        v-if="
                                                            gap_fixedAssetsAccountableAccount &&
                                                            gap_fixedAssetsAccountableAccount.gapData &&
                                                            gap_fixedAssetsAccountableAccount
                                                                .gapData
                                                                .toProposeGlAccountableAccounts
                                                        "
                                                    >
                                                        <v-select-filled
                                                            v-model="
                                                                props.item.changedAccountableAccount
                                                            "
                                                            :items="
                                                                gap_fixedAssetsAccountableAccount
                                                                    .gapData
                                                                    .toProposeGlAccountableAccounts
                                                            "
                                                            item-value="value"
                                                            :hide-details="true"
                                                            density="compact"
                                                            :item-title="(item) => item.text"
                                                            @update:model-value="
                                                                changeNoGapFixedAssetAccountableAccounts(
                                                                    'fixedAssets',
                                                                )
                                                            "
                                                        />
                                                    </td>
                                                    <td v-else />

                                                    <td class="text-left">
                                                        {{ props.item.aaNameDepreciation || "" }}
                                                    </td>

                                                    <td class="text-left">
                                                        {{ props.item.date || "" }}
                                                    </td>

                                                    <td class="text-left">
                                                        {{ props.item.wording || "" }}
                                                    </td>

                                                    <td class="text-left">
                                                        {{ props.item.type || "" }}
                                                    </td>

                                                    <td class="text-left">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                props.item.rate,
                                                                { currency: "" },
                                                            )
                                                        }}
                                                    </td>

                                                    <td class="text-right">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                props.item.alNetAmountSigned,
                                                                { currency: "" },
                                                            )
                                                        }}
                                                    </td>

                                                    <td class="text-right">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                props.item
                                                                    .previousDepreciationAmountSigned,
                                                                { currency: "" },
                                                            )
                                                        }}
                                                    </td>

                                                    <!-- <td class="text-right -->
                                                </tr>
                                            </template>
                                        </oss-data-table>
                                    </template>

                                    <!-- // changeDepreciationAccountableAccountGap -->
                                    <template v-else-if="changeDepreciationAccountableAccountGap">
                                        <div class="pl-2 pr-4">
                                            <h2 class="pb-2">
                                                Aucun écart global sur les COMPTES D'AMORTISSEMENT
                                                LINEAIRES, il suffit de modifier les comptes
                                                comptables
                                            </h2>

                                            <v-row
                                                no-gutters
                                                v-if="gap_depreciationAccountableAccount"
                                            >
                                                <v-col cols="4" class="d-flex align-center">
                                                    <h4>Ecarts sur le grand livre :</h4>
                                                </v-col>

                                                <v-col cols="8">
                                                    <oss-data-table
                                                        :headers="gapsGlHeaders"
                                                        :items="
                                                            gap_depreciationAccountableAccount
                                                                .gapData.glWithoutImportResume
                                                        "
                                                        :striped="true"
                                                        :x-dense="true"
                                                        class="table"
                                                    >
                                                        <template v-slot:item="props">
                                                            <tr>
                                                                <td
                                                                    class="text-left"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{ props.item.aaName || "" }}
                                                                </td>

                                                                <td
                                                                    class="text-right"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item.glSum,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td
                                                                    class="text-right"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item
                                                                                .alreadyImportedSum,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td
                                                                    class="text-right"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item.importedSum,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td
                                                                    class="text-right"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item.gap,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </template>

                                                        <template v-slot:body.append>
                                                            <tr class="x-dense">
                                                                <th class="text-start">Totaux</th>
                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_depreciationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "glSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_depreciationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "alreadyImportedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_depreciationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "importedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_depreciationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "gap",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>
                                                            </tr>
                                                        </template>
                                                    </oss-data-table>
                                                </v-col>
                                            </v-row>

                                            <v-row
                                                no-gutters
                                                v-if="gap_depreciationAccountableAccount"
                                                class="pt-4 pb-2"
                                            >
                                                <v-col
                                                    v-if="
                                                        gap_depreciationAccountableAccount.gapData &&
                                                        !gap_depreciationAccountableAccount.gapData
                                                            .sumGap
                                                    "
                                                >
                                                    <h3>
                                                        Détails des AMORTISSEMENTS LINEAIRES
                                                        importées dont les comptes comptables ne
                                                        trouvent pas de correspondance dans le grand
                                                        livre :
                                                    </h3>
                                                </v-col>
                                            </v-row>

                                            <oss-data-table
                                                :headers="gapsImportedLinesHeaders28"
                                                :items="
                                                    gap_depreciationAccountableAccount.gapData
                                                        .importLinesWithoutGl
                                                "
                                                :striped="true"
                                                :x-dense="true"
                                                class="table"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td class="text-left">
                                                            {{ props.item.aaNameFixedAsset || "" }}
                                                        </td>

                                                        <td
                                                            class="text-left"
                                                            :style="
                                                                gapSelectColor(
                                                                    props.item,
                                                                    'aaNameDepreciation',
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                props.item.aaNameDepreciation || ""
                                                            }}
                                                        </td>

                                                        <td class="text-left">
                                                            <v-select-filled
                                                                v-if="
                                                                    gap_depreciationAccountableAccount &&
                                                                    gap_depreciationAccountableAccount.gapData &&
                                                                    gap_depreciationAccountableAccount
                                                                        .gapData
                                                                        .toProposeGlAccountableAccounts
                                                                "
                                                                v-model="
                                                                    props.item
                                                                        .changedAccountableAccount
                                                                "
                                                                :items="
                                                                    gap_depreciationAccountableAccount
                                                                        .gapData
                                                                        .toProposeGlAccountableAccounts
                                                                "
                                                                :hide-details="true"
                                                                @update:model-value="
                                                                    changeNoGapFixedAssetAccountableAccounts(
                                                                        'depreciations',
                                                                    )
                                                                "
                                                                density="compact"
                                                                :item-title="(item) => item.text"
                                                            />
                                                        </td>

                                                        <td class="text-left">
                                                            {{ props.item.date || "" }}
                                                        </td>

                                                        <td class="text-left">
                                                            {{ props.item.wording || "" }}
                                                        </td>

                                                        <td class="text-left">
                                                            {{ props.item.type || "" }}
                                                        </td>

                                                        <td class="text-left">
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    props.item.rate,
                                                                    { currency: "" },
                                                                )
                                                            }}
                                                        </td>

                                                        <td class="text-right">
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    props.item.alNetAmountSigned,
                                                                    { currency: "" },
                                                                )
                                                            }}
                                                        </td>

                                                        <td class="text-right">
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    props.item
                                                                        .previousDepreciationAmountSigned,
                                                                    { currency: "" },
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </oss-data-table>
                                        </div>
                                    </template>

                                    <!-- // changeDerogationAccountableAccountGap -->
                                    <template v-else-if="changeDerogationAccountableAccountGap">
                                        <div class="pl-2 pr-4">
                                            <h2 class="pb-2">
                                                Aucun écart global sur les COMPTES D'AMORTISSEMENT
                                                DEROGATOIRE, il suffit de modifier les comptes
                                                comptables
                                            </h2>

                                            <v-row
                                                no-gutters
                                                v-if="gap_derogationAccountableAccount"
                                            >
                                                <v-col cols="4" class="d-flex align-center">
                                                    <h4>Ecarts sur le grand livre :</h4>
                                                </v-col>

                                                <v-col cols="8">
                                                    <oss-data-table
                                                        :headers="gapsGlHeaders"
                                                        :items="
                                                            gap_derogationAccountableAccount.gapData
                                                                .glWithoutImportResume
                                                        "
                                                        :striped="true"
                                                        :x-dense="true"
                                                        class="table"
                                                    >
                                                        <template v-slot:item="props">
                                                            <tr>
                                                                <td
                                                                    class="text-left"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{ props.item.aaName || "" }}
                                                                </td>

                                                                <td
                                                                    class="text-right"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item.glSum,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td
                                                                    class="text-right"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item
                                                                                .alreadyImportedSum,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td
                                                                    class="text-right"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item.importedSum,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td
                                                                    class="text-right"
                                                                    :style="
                                                                        glGapColor(props.item.gap)
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            props.item.gap,
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </template>

                                                        <template v-slot:body.append>
                                                            <tr class="x-dense">
                                                                <th class="text-start">Totaux</th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_derogationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "glSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_derogationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "alreadyImportedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "importedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>

                                                                <th class="text-end">
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumColumn(
                                                                                gap_derogationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "gap",
                                                                            ),
                                                                            { currency: "" },
                                                                        )
                                                                    }}
                                                                </th>
                                                            </tr>
                                                        </template>
                                                    </oss-data-table>
                                                </v-col>
                                            </v-row>

                                            <v-row
                                                no-gutters
                                                v-if="gap_depreciationAccountableAccount"
                                                class="pt-4 pb-2"
                                            >
                                                <v-col
                                                    v-if="
                                                        gap_depreciationAccountableAccount.gapData &&
                                                        !gap_depreciationAccountableAccount.gapData
                                                            .sumGap
                                                    "
                                                >
                                                    <h3>
                                                        Détails des AMORTISSEMENTS DEROGATOIRES
                                                        importées dont les comptes comptables ne
                                                        trouvent pas de correspondance dans le grand
                                                        livre :
                                                    </h3>
                                                </v-col>
                                            </v-row>
                                        </div>

                                        <oss-data-table
                                            :headers="gapsImportedLinesHeaders28"
                                            :items="
                                                gap_derogationAccountableAccount.gapData
                                                    .importLinesWithoutGl
                                            "
                                            :striped="true"
                                            :x-dense="true"
                                            class="table"
                                        >
                                            <template v-slot:item="props">
                                                <tr>
                                                    <td class="text-left">
                                                        {{ props.item.aaNameFixedAsset || "" }}
                                                    </td>

                                                    <td
                                                        class="text-left"
                                                        :style="
                                                            gapSelectColor(
                                                                props.item,
                                                                'aaNameDepreciation',
                                                            )
                                                        "
                                                    >
                                                        {{ props.item.aaNameDepreciation || "" }}
                                                    </td>

                                                    <td class="text-left">
                                                        <v-select-filled
                                                            v-if="
                                                                gap_derogationAccountableAccount &&
                                                                gap_derogationAccountableAccount.gapData &&
                                                                gap_derogationAccountableAccount
                                                                    .gapData
                                                                    .toProposeGlAccountableAccounts
                                                            "
                                                            v-model="
                                                                props.item.changedAccountableAccount
                                                            "
                                                            :items="
                                                                gap_derogationAccountableAccount
                                                                    .gapData
                                                                    .toProposeGlAccountableAccounts
                                                            "
                                                            :hide-details="true"
                                                            @update:model-value="
                                                                changeNoGapFixedAssetAccountableAccounts(
                                                                    'depreciations',
                                                                )
                                                            "
                                                            density="compact"
                                                            :item-title="(item) => item.text"
                                                        />
                                                    </td>

                                                    <td class="text-left">
                                                        {{ props.item.date || "" }}
                                                    </td>

                                                    <td class="text-left">
                                                        {{ props.item.wording || "" }}
                                                    </td>

                                                    <td class="text-left">
                                                        {{ props.item.type || "" }}
                                                    </td>

                                                    <td class="text-left">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                props.item.rate,
                                                                { currency: "" },
                                                            )
                                                        }}
                                                    </td>

                                                    <td class="text-right">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                props.item.alNetAmountSigned,
                                                                { currency: "" },
                                                            )
                                                        }}
                                                    </td>

                                                    <td class="text-right">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                props.item
                                                                    .previousDepreciationAmountSigned,
                                                                { currency: "" },
                                                            )
                                                        }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </oss-data-table>
                                    </template>
                                </v-window-item>
                            </v-window>
                        </oss-dialog>

                        <!-- ++ FULL GAPS DIALOG - GAPS BETWEEN IMPORT AND GENERAL LEDGER DIALOG -->
                        <oss-dialog
                            v-if="!someDecliningDepreciationError && fullGapsDialog"
                            v-model="fullGapsDialog"
                            withoutHeader="true"
                            :actions="actions"
                            @close="closeDialog()"
                            min-width="80vw"
                        >
                            <v-window v-model="incompleteFECStep">
                                <!-- ** incompleteFECStep 1 -->
                                <v-window-item :value="'alert'">
                                    <v-alert
                                        border="start"
                                        border-color="red"
                                        elevation="0"
                                        class="py-4 mb-0"
                                    >
                                        <h3>ATTENTION ECARTS !</h3>
                                        <h3>
                                            Les totaux du fichier importé sont différents des totaux
                                            des reprises des à nouveaux
                                        </h3>
                                        <h4>
                                            Vérifier, avant de continuer : l'import concerne bien la
                                            dernière période clôturée ?
                                        </h4>
                                        <v-row no-gutters class="d-flex pl-4 py-0">
                                            <v-spacer />

                                            <v-col cols="auto" class="px-4">
                                                <v-btn
                                                    dense
                                                    rounded
                                                    elevation="0"
                                                    @click="
                                                        fullGapsDialog = false;
                                                        accountableAccountLinesSelected = [];
                                                        importFunction();
                                                    "
                                                >
                                                    Non : ré-importer le bon fichier
                                                </v-btn>
                                            </v-col>

                                            <v-col cols="1">
                                                <v-btn
                                                    dense
                                                    rounded
                                                    elevation="0"
                                                    @click="
                                                        incompleteFECStep = getIncompleteFECStep
                                                    "
                                                >
                                                    Oui
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-alert>
                                </v-window-item>

                                <!-- ** incompleteFECStep 2 -->
                                <v-window-item :value="'accountableAccountsList'">
                                    <h1 class="d-flex px-4 py-0 justify-center text-primary">
                                        Ces comptes du grand livre ont un solde inférieur à l'import
                                    </h1>

                                    <h2
                                        v-if="gapToAffect"
                                        class="d-flex px-4 pb-4 justify-center text-primary"
                                    >
                                        S'il est impossible d'identifier les lignes à intégrer, il
                                        sera indispensable de corriger le fichier
                                        d'immobilisations/amortissements N-1 et de le réimporter.
                                    </h2>

                                    <h2 class="d-flex px-4 pb-0 justify-center text-primary">
                                        Soyez vigilants ! Il peut s'agir d'immobilisations déjà
                                        sorties.
                                    </h2>

                                    <h2 class="d-flex px-4 pb-2 justify-center text-primary">
                                        Dans ce cas, nous vous conseillons de les effacer du tableau
                                        d'immobilisations/amortissements N-1 et de procéder à un
                                        nouvel import.
                                    </h2>

                                    <h3 class="d-flex px-4 pb-2 justify-center">
                                        Cette fonction sert à intégrer des immobilisations ou un
                                        amortissements présents dans le logiciel d'immobilisation,
                                        mais pas comptabilisés.
                                    </h3>

                                    <h3 class="d-flex px-4 pb-2 justify-center">
                                        Elle va générer, au premier jour de l'exercice en cours, des
                                        écritures de type "2 à 404" ou "68 à 28".
                                    </h3>

                                    <h3 class="d-flex px-4 py-2 justify-center">
                                        Les lignes que vous allez sélectionner doivent, cumulées,
                                        obtenir le même montant que l'écart.
                                    </h3>

                                    <div v-for="(group, key) in gaps" :key="key">
                                        <v-list-item :key="key" class="oss-list-item ma-0" ripple>
                                            <v-list-item-title class="pb-2">
                                                <v-row
                                                    no-gutter
                                                    :class="'pt-2 ' + glGapColor(gapToAffect)"
                                                >
                                                    <v-col>
                                                        <h3>Ecarts sur la racine {{ key }}</h3>
                                                    </v-col>

                                                    <v-spacer />

                                                    <v-col>
                                                        <h4>
                                                            A identifier :
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    group.sumGap,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </h4>
                                                    </v-col>

                                                    <v-spacer />

                                                    <v-col>
                                                        <h4>
                                                            Total lignes séléctionnées :
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    sumSelectedGaps,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </h4>
                                                    </v-col>

                                                    <v-spacer />

                                                    <v-col>
                                                        <h4>
                                                            Ecart restant :
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    gapToAffect,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                            <div
                                                v-for="(accAccount, index) in gaps[key]
                                                    .importWithoutGlResume"
                                                :key="index"
                                            >
                                                <v-list-item class="oss-list-item" :key="index">
                                                    <v-list-item-subtitle>
                                                        <v-row
                                                            no-gutters
                                                            class="d-flex align-center"
                                                        >
                                                            <v-col
                                                                >&bull; c/{{ accAccount.aaName }}
                                                                - Total importé :
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        accAccount.importedSum,
                                                                        undefined,
                                                                    )
                                                                }}
                                                                - Total à nouveaux :
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        accAccount.glSum,
                                                                        undefined,
                                                                    )
                                                                }}
                                                                - Ecart :
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        accAccount.gap,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </v-col>

                                                            <v-spacer />

                                                            <v-col
                                                                cols="1"
                                                                class="d-flex align-center justify-center"
                                                            >
                                                                <v-row no-gutters>
                                                                    <v-col
                                                                        cols="6"
                                                                        class="align-center"
                                                                    >
                                                                        <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                                                    </v-col>
                                                                    <!-- <v-card-actions style="width: 20px"> -->
                                                                    <v-col
                                                                        cols="6"
                                                                        class="align-center"
                                                                    >
                                                                        <v-btn-icon
                                                                            :icon="
                                                                                isAccAccountExpanded(
                                                                                    accAccount.aaName,
                                                                                )
                                                                                    ? '$fa-chevron-up'
                                                                                    : '$fa-chevron-down'
                                                                            "
                                                                            data-cy="CheckFixedAssetsCutPrevious-immobilisations"
                                                                            @click="
                                                                                addRemoveAccAccountExpanded(
                                                                                    accAccount.aaName,
                                                                                    key,
                                                                                )
                                                                            "
                                                                        />
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item-subtitle>

                                                    <template
                                                        v-if="
                                                            isAccAccountExpanded(accAccount.aaName)
                                                        "
                                                    >
                                                        <v-card>
                                                            <v-card-text>
                                                                <v-data-table
                                                                    :headers="
                                                                        selectedGapAccAccountImportedLinesHea
                                                                    "
                                                                    :items="
                                                                        expandedAccAccountImportedLinesWithoutGl(
                                                                            accAccount.aaName,
                                                                        )
                                                                    "
                                                                    fixed-header
                                                                    v-model="selectedFullGapsLines"
                                                                    :items-per-page="-1"
                                                                    hide-default-footer
                                                                    disable-pagination
                                                                    class="table"
                                                                    show-select
                                                                    :single-select="singleSelect"
                                                                    :item-value="
                                                                        (item) => item.index
                                                                    "
                                                                    density="compact"
                                                                >
                                                                    <template
                                                                        v-slot:item.alNetAmountSigned="{
                                                                            item,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            newCommonFormatCurrency(
                                                                                item.alNetAmountSigned,
                                                                                undefined,
                                                                            )
                                                                        }}
                                                                    </template>

                                                                    <template
                                                                        v-slot:item.previousDepreciationAmountSigned="{
                                                                            item,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            newCommonFormatCurrency(
                                                                                item.previousDepreciationAmountSigned,
                                                                                undefined,
                                                                            )
                                                                        }}
                                                                    </template>
                                                                </v-data-table>
                                                            </v-card-text>
                                                        </v-card>
                                                    </template>
                                                </v-list-item>
                                            </div>
                                        </v-list-item>
                                    </div>
                                </v-window-item>

                                <!-- ** incompleteFECStep 3 -->
                                <v-window-item :value="'glWithoutImportResume'">
                                    <h2 class="d-flex px-4 py-0">
                                        Le solde du grand livre est supérieur au solde de l'import :
                                    </h2>

                                    <v-row
                                        no-gutters
                                        class="d-flex px-4 py-0"
                                        v-if="gap_fixedAssetsAccountableAccount"
                                    >
                                        <v-col cols="8" class="d-flex align-center">
                                            <h4>
                                                Merci d'intégrer les comptes / montants suivants
                                                dans le fichier et de renouveler l'import :
                                            </h4>
                                        </v-col>

                                        <v-col cols="4">
                                            <oss-data-table
                                                :headers="gapsGlWithoutImportsHeaders"
                                                :items="
                                                    gap_fixedAssetsAccountableAccount.gapData
                                                        .glWithoutImportResume
                                                "
                                                :striped="true"
                                                :x-dense="true"
                                                class="table"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td
                                                            class="text-left"
                                                            :style="glGapColor(props.item.gap)"
                                                        >
                                                            {{ props.item.aaName || "" }}
                                                        </td>

                                                        <td
                                                            class="text-right"
                                                            :style="glGapColor(props.item.gap)"
                                                        >
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    props.item.gap,
                                                                    { currency: "" },
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                </template>

                                                <template v-slot:body.append>
                                                    <tr class="x-dense">
                                                        <th class="text-start">Totaux</th>

                                                        <th class="text-end">
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    sumColumn(
                                                                        gap_fixedAssetsAccountableAccount
                                                                            .gapData
                                                                            .glWithoutImportResume,
                                                                        "gap",
                                                                    ),
                                                                    { currency: "" },
                                                                )
                                                            }}
                                                        </th>
                                                    </tr>
                                                </template>
                                            </oss-data-table>
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        no-gutters
                                        v-if="gap_fixedAssetsAccountableAccount"
                                        class="pt-4 pb-2"
                                    >
                                        <v-col
                                            v-if="
                                                gap_fixedAssetsAccountableAccount.gapData &&
                                                !gap_fixedAssetsAccountableAccount.gapData.sumGap
                                            "
                                        >
                                            <h3 class="py-2">
                                                Détails des immobilisations importées dont les
                                                comptes comptables ne trouvent pas de correspondance
                                                dans le grand livre :
                                            </h3>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                            </v-window>
                        </oss-dialog>

                        <!-- ++ generateLocalSpread = errorsOnFirstOrMiddleDepreciations -->
                        <oss-dialog
                            v-if="
                                !someDecliningDepreciationError &&
                                gap68LOnRegulN_1Errors &&
                                gap68LOnRegulN_1Errors.length
                            "
                            v-model="gap68LOnRegulN_1ErrorsDialog"
                            withoutHeader="true"
                            @close="closeDialog()"
                            @valid="updateLinearSpreadStartDate()"
                            validTitle="Enregistrer"
                            :valid-disabled="!showUpdatedLinearSpreadStartDateBtn"
                            min-width="90vw"
                        >
                            <!-- :actions="actions" -->
                            <!-- width="80%" -->
                            <!-- @close="closeDialogGap68OnRegulN_1Errors()" -->

                            <v-alert
                                border="start"
                                border-color="red"
                                elevation="0"
                                class="py-4 mb-0"
                            >
                                <h3>ATTENTION ECARTS !</h3>
                                <h3>
                                    Les immobilisations suivantes présentent un écart lors de la
                                    génération de la reprise.
                                </h3>
                                <h4 class="pb-4">
                                    Avant de continuer : corriger la date de mise en service.
                                </h4>

                                <v-data-table
                                    :items="gap68LOnRegulN_1Errors"
                                    :headers="gap68OnRegulN_1ErrorsHeaders"
                                    fixed-header
                                    max-height="56vh"
                                    :items-per-page="-1"
                                    hide-default-footer
                                    disable-pagination
                                    class="table"
                                    density="compact"
                                >
                                    <template #no-data>Aucune charge à réintégrer</template>

                                    <template v-slot:item="props">
                                        <tr>
                                            <!-- // ** accountableAccount -->
                                            <td
                                                v-if="
                                                    props.item.currentAlAcrData.accountableAccount
                                                        .name
                                                "
                                                class="text-left"
                                            >
                                                {{
                                                    props.item.currentAlAcrData.accountableAccount
                                                        .name
                                                }}
                                            </td>

                                            <!-- // ** wording -->
                                            <td
                                                v-if="props.item.currentAlAcrData.fixedAssetWording"
                                                class="text-left"
                                            >
                                                {{ props.item.currentAlAcrData.fixedAssetWording }}
                                            </td>

                                            <!-- // ** date -->
                                            <td
                                                v-if="props.item.currentAlAcrData.date"
                                                class="text-center"
                                            >
                                                {{ formatDate(props.item.currentAlAcrData.date) }}
                                            </td>

                                            <!-- // ** selectedYearDuration -->
                                            <td
                                                v-if="
                                                    props.item.currentAlAcrData.selectedYearDuration
                                                "
                                                class="text-center"
                                            >
                                                {{
                                                    props.item.currentAlAcrData.selectedYearDuration
                                                }}
                                            </td>

                                            <!-- // ** alNetAmountSigned -->
                                            <td
                                                v-if="props.item.currentAlAcrData.alNetAmountSigned"
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.currentAlAcrData
                                                            .alNetAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                            </td>

                                            <!-- // ** previousDepreciationAmountSigned -->
                                            <td
                                                v-if="
                                                    props.item.currentAlAcrData
                                                        .previousDepreciationAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.currentAlAcrData
                                                            .previousDepreciationAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                            </td>

                                            <!-- // ** calculatedSumAmount -->
                                            <td
                                                v-if="props.item.calculatedSumAmount"
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.calculatedSumAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </td>

                                            <!-- // ** regul68Gap -->
                                            <td v-if="props.item.regul68Gap" class="text-right">
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.regul68Gap,
                                                        undefined,
                                                    )
                                                }}
                                            </td>

                                            <!-- // ** suggestedDate -->
                                            <td v-if="props.item.suggestedDate" class="text-center">
                                                <b>{{ formatDate(props.item.suggestedDate) }}</b>
                                            </td>

                                            <td>
                                                <oss-date-picker-filled
                                                    v-model="
                                                        props.item.currentAlAcrData
                                                            .linearSpreadStartDate
                                                    "
                                                    style="flex: 1"
                                                    :textFieldReadOnly="false"
                                                    hide-details
                                                >
                                                </oss-date-picker-filled>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-alert>
                        </oss-dialog>
                    </template>

                    <template
                        v-else-if="
                            errorsOnFullDepreciatedFixedAssets &&
                            errorsOnFullDepreciatedFixedAssets.length
                        "
                    >
                        <!-- ++ FULL DEPRECIATED FIXED ASSETS DIALOG - GAPS BETWEEN calculated depreciations and imported -->
                        <oss-dialog
                            v-if="fullDepreciatedFixedAssetsDialog"
                            v-model="fullDepreciatedFixedAssetsDialog"
                            withoutHeader="true"
                            :actions="actions"
                            @close="closeDialog()"
                            min-width="80vw"
                        >
                            <v-window v-model="incompleteFECStep">
                                <!-- ** incompleteFECStep  -->
                                <v-window-item :value="'fullDepreciatedFixedAssets'">
                                    <h2 class="d-flex px-4 py-0">
                                        Des immobilisations complétement amorties ont un écart entre
                                        le cumul d'amortissements importé et le prix d'achat
                                    </h2>

                                    <h3 class="d-flex px-4 pt-4">
                                        bobbee va générer une écriture (68 à 28) de régularisation
                                        en N, par immobilisation concernée
                                    </h3>
                                    <v-data-table
                                        :headers="fullDepreciatedFixedAssetsHeaders"
                                        :items="errorsOnFullDepreciatedFixedAssets"
                                        fixed-header
                                        :items-per-page="-1"
                                        hide-default-footer
                                        disable-pagination
                                        class="table"
                                        item-key="index"
                                        density="compact"
                                    >
                                        <template v-slot:item.date="{ item }">
                                            {{ formatDate(item.date) }}
                                        </template>
                                        <template v-slot:item.linearSpreadEndDate="{ item }">
                                            {{ formatDate(item.linearSpreadEndDate) }}
                                        </template>
                                        <template v-slot:item.alNetAmountSigned="{ item }">
                                            {{
                                                newCommonFormatCurrency(
                                                    item.alNetAmountSigned,
                                                    undefined,
                                                )
                                            }}
                                        </template>
                                        <template
                                            v-slot:item.previousDepreciationAmountSigned="{ item }"
                                        >
                                            {{
                                                newCommonFormatCurrency(
                                                    item.previousDepreciationAmountSigned,
                                                    undefined,
                                                )
                                            }}
                                        </template>
                                        <template v-slot:item.gap="{ item }">
                                            {{ newCommonFormatCurrency(item.gap, undefined) }}
                                        </template>
                                    </v-data-table>
                                </v-window-item>
                            </v-window>
                        </oss-dialog>
                    </template>
                </template>

                <!-- +++ GL 20 - 21 - 22 - 23 - 24 ++++++++++ -->

                <v-card
                    v-if="gl2_total || gl2_total_filtered"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    Immobilisations - c/20 21 22 23 24 - Solde fin d'exercice

                                    {{
                                        newCommonFormatCurrency(gl2_total)
                                    }}
                                     (dont solde début d'exercice
                                    {{
                                        newCommonFormatCurrency(gl2_total_filtered)
                                    }}
                                    à reprendre)
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <!-- <v-card-actions style="width: 20px"> -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="showGL2 ? '$fa-chevron-up' : '$fa-chevron-down'"
                                        data-cy="CheckFixedAssetsCutPrevious-immobilisations"
                                        @click="showGL2 = !showGL2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- ** GeneralLedger -->
                    <v-expand-transition>
                        <div v-show="showGL2">
                            <v-row>
                                <v-col :key="refreshGeneralLedger2">
                                    <GeneralLedger
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriod.id"
                                        :accountableAccountFilter="['20', '21', '22', '23', '24']"
                                        v-if="accountingPeriod"
                                        :inNm1="showNm1_2"
                                        @nm1Changed="showNm1_2 = !showNm1_2"
                                        @query-done="onQueryDone2"
                                    >
                                    </GeneralLedger>
                                    <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition> </v-card
                >
                
                <!-- ++ GL 28 amos -->
                <v-card
                    v-if="gl28_total || gl28_total_filtered"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    Amortissements - c/28 - Solde fin d'exercice
                                    {{
                                        newCommonFormatCurrency(gl28_total)
                                    }}
                                     (dont solde début d'exercice
                                    {{
                                        newCommonFormatCurrency(gl28_total_filtered)
                                    }}
                                    à reprendre)
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <!-- <v-card-actions style="width: 20px"> -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="showGL28 ? '$fa-chevron-up' : '$fa-chevron-down'"
                                        @click="showGL28 = !showGL28"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- ** GeneralLedger -->
                    <v-expand-transition>
                        <div v-show="showGL28">
                            <v-row>
                                <v-col :key="refreshGeneralLedger28">
                                    <GeneralLedger
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriod.id"
                                        :accountableAccountFilter="['28']"
                                        v-if="accountingPeriod"
                                        :inNm1="showNm1_145"
                                        @nm1Changed="showNm1_145 = !showNm1_145"
                                        @query-done="onQueryDone28"
                                    >
                                    </GeneralLedger>
                                    <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- // +++++ GL 145 ++++++++++ -->
                <v-card
                    v-if="gl145_total || gl145_total_filtered"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    Amortissements dérogatoires - c/145 - Solde fin d'exercice
                                    {{
                                        newCommonFormatCurrency(gl145_total)
                                    }}
                                     (dont solde début d'exercice
                                    {{
                                        newCommonFormatCurrency(gl145_total_filtered)
                                    }}
                                    à reprendre)
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <!-- <v-card-actions style="width: 20px"> -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="showGL145 ? '$fa-chevron-up' : '$fa-chevron-down'"
                                        @click="showGL145 = !showGL145"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- ** GeneralLedger -->
                    <v-expand-transition>
                        <div v-show="showGL145">
                            <v-row>
                                <v-col :key="refreshGeneralLedger145">
                                    <GeneralLedger
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriod.id"
                                        :accountableAccountFilter="['145']"
                                        v-if="accountingPeriod"
                                        :inNm1="showNm1_145"
                                        @nm1Changed="showNm1_145 = !showNm1_145"
                                        @query-done="onQueryDone145"
                                    >
                                    </GeneralLedger>
                                    <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- +++++ GL 25 ++++++++++ -->
                <v-card
                    v-if="gl25_total || gl25_total_filtered"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    Participations ou créances rattachées à des participations -
                                    c/25 - Solde fin d'exercice
                                    {{
                                        newCommonFormatCurrency(gl25_total)
                                    }}
                                     (dont solde début d'exercice
                                    {{
                                        newCommonFormatCurrency(gl25_total_filtered)
                                    }}
                                    à reprendre)
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validatedPayrolls" color="primary"  class="px-2 pt-1">
                                            check_circle
                                        </v-icon> -->
                                </v-col>
                                <!-- <v-card-actions style="width: 20px"> -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn icon @click="showGL25 = !showGL25">
                                        <v-icon v-if="showGL25 === false">
                                            $keyboard_arrow_down
                                        </v-icon>
                                        <v-icon v-else> $keyboard_arrow_up </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- ** GeneralLedger -->
                    <v-expand-transition>
                        <div v-show="showGL25">
                            <v-row>
                                <v-col :key="refreshGeneralLedger25">
                                    <GeneralLedger
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriod.id"
                                        :accountableAccountFilter="['25']"
                                        v-if="accountingPeriod"
                                        :inNm1="showNm1_25"
                                        @nm1Changed="showNm1_25 = !showNm1_25"
                                        @query-done="onQueryDone25"
                                    >
                                    </GeneralLedger>
                                    <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- +++++ GL 26 ++++++++++ -->
                <v-card
                    v-if="gl26_total || gl26_total_filtered"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    Participations ou créances rattachées à des participations -
                                    c/26 - Solde fin d'exercice
                                    {{
                                        newCommonFormatCurrency(gl26_total)
                                    }}
                                     (dont solde début d'exercice
                                    {{
                                        newCommonFormatCurrency(gl26_total_filtered)
                                    }}
                                    à reprendre)
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <!-- <v-card-actions style="width: 20px"> -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="showGL26 ? '$fa-chevron-up' : '$fa-chevron-down'"
                                        @click="showGL26 = !showGL26"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- ** GeneralLedger -->
                    <v-expand-transition>
                        <div v-show="showGL26">
                            <v-row>
                                <v-col :key="refreshGeneralLedger26">
                                    <GeneralLedger
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriod.id"
                                        :accountableAccountFilter="['26']"
                                        v-if="accountingPeriod"
                                        :inNm1="showNm1_26"
                                        @nm1Changed="showNm1_26 = !showNm1_26"
                                        @query-done="onQueryDone26"
                                    >
                                    </GeneralLedger>
                                    <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- +++++ GL 27 ++++++++++ -->
                <v-card
                    v-if="gl27_total || gl27_total_filtered"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    Autres immobilisations financières - c/27 - Solde fin d'exercice
                                    {{
                                        newCommonFormatCurrency(gl27_total)
                                    }}
                                     (dont solde début d'exercice
                                    {{
                                        newCommonFormatCurrency(gl27_total_filtered)
                                    }}
                                    à reprendre)
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <!-- <v-card-actions style="width: 20px"> -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="showGL27 ? '$fa-chevron-up' : '$fa-chevron-down'"
                                        @click="showGL27 = !showGL27"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- ** GeneralLedger -->
                    <v-expand-transition>
                        <div v-show="showGL27">
                            <v-row>
                                <v-col :key="refreshGeneralLedger27">
                                    <GeneralLedger
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriod.id"
                                        :accountableAccountFilter="['27']"
                                        v-if="accountingPeriod"
                                        :inNm1="showNm1_27"
                                        @nm1Changed="showNm1_27 = !showNm1_27"
                                        @query-done="onQueryDone27"
                                    >
                                    </GeneralLedger>
                                    <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>
            </template>

            <!-- ** connectedDocuments -->
            <template v-if="!loading && !dataLoading">
                <AuditConnectedAcrDocuments
                    :connectedDocuments="connectedDocuments"
                    :companyId="companyId"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="undefined"
                    @unlinkedDocument="unlinkDocument($event)"
                    @showLinkedDocument="showLinkedDocument($event)"
                />
            </template>

            <!-- ** results -->
            <template v-if="!loading && !dataLoading && !currentPeriodIsFirstPeriod">
                <AuditConnectedAcrResults :results="results" :companyId="companyId" />
            </template>

            <CheckFixedAssetsCutPreviousImport
                v-model="importWizardDialog"
                @close="
                    importLoading = false;
                    importWizardDialog = false;
                "
                :title="'Selectionnez le fichier à importer (.csv, .xlsx, .tsv .txt)'"
                v-if="importWizardDialog"
                @query-done="onFixedAssetsImported"
            />

            <!-- ********* DIALOG - CREATE PROVISION ******* -->
            <!-- <v-dialog v-if="cutDialog" v-model="cutDialog" width="80%" class="justify-space-around">
                <v-card>
                    <v-card-title>
                        Reprise des immobilisations et amortissements : transformation des écritures
                        globales en écritures détaillées
                    </v-card-title>

                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <GetEmptyDocumentsTable
                                v-if="
                                    cutDocument &&
                                    cutDocument.accountingLines &&
                                    cutDocument.accountingLines.create &&
                                    cutDocument.accountingLines.create.length
                                "
                                :documentAlsCreate="cutDocument.accountingLines.create"
                                :accountableAccounts="storeAccountableAccounts"
                            />

                            <v-divider />

                            <v-card-actions style="padding-right: 24px; padding-left: 24px">
                                <v-spacer />

                                <v-tooltip v-if="disabledStoreCutDocument" location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <v-btn
                                            class="ma-2"
                                            v-bind="props"
                                            :loading="storeCutsLoading"
                                        >
                                            Valider
                                        </v-btn>
                                    </template>
                                    <span>Ecriture déséquilibrée</span>
                                </v-tooltip>

                                <v-btn
                                    v-else
                                    rounded
                                    class="ma-2 btn"
                                    :loading="storeCutsLoading"
                                    @click="storeCuts()"
                                >
                                    Valider
                                </v-btn>
                            </v-card-actions>
                        </v-window-item>
                    </v-window>
                </v-card>
            </v-dialog> -->

            <!-- ********* DIALOG - CREATE PROVISION - NEW VERSION ******* -->
            <oss-dialog
                v-if="cutDialog"
                v-model="cutDialog"
                width="80vw"
                class="justify-space-around"
                title="Reprise des immobilisations et amortissements : transformation des écritures
                        globales en écritures détaillées"
                @valid="storeCuts()"
                validTitle="Valider"
                :validDisabled="disabledStoreCutDocument"
                :validLoading="storeCutsLoading"
            >
                <GetEmptyDocumentsTable
                    v-if="
                        cutDocument &&
                        cutDocument.accountingLines &&
                        cutDocument.accountingLines.create &&
                        cutDocument.accountingLines.create.length
                    "
                    :documentAlsCreate="cutDocument.accountingLines.create"
                    :accountableAccounts="storeAccountableAccounts"
                />
            </oss-dialog>

            <!-- ++ longComment -->
            <v-card class="pa-6 mt-4">
                <v-row>
                    <v-col cols="5" class="ma-auto">
                        <v-card-title class="ma-0 pa-0">
                            <h5 class="pl-4">Commentaires détaillés</h5>
                        </v-card-title>
                    </v-col>

                    <v-spacer />

                    <!-- ** icons *************** -->
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-row>
                            <v-col cols="6" class="align-center pa-0">
                                <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                            </v-col>

                            <!-- ** expand icon -->
                            <v-col cols="6" class="align-center pa-0">
                                <v-btn-icon
                                    :icon="
                                        longCommentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                    "
                                    data-cy="CheckFixedAssetsCutPrevious-commentairesDetailles"
                                    @click="longCommentExpand = !longCommentExpand"
                                    style="width: 40px"
                                    class="d-inline px-2"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-card-text v-if="longCommentExpand" transition="longCommentExpand">
                    <!-- <v-expand-transition no-gutters v-show="longCommentExpand"> -->
                    <v-card-text>
                        <v-textarea
                            v-model="longComment"
                            :disabled="commentDisabled"
                            auto-grow
                            style="border: 1px #ededed solid"
                            outlined
                        />
                    </v-card-text>

                    <v-card-text class="text-end">
                        <!-- ** Store data -->
                        <v-btn
                            :disabled="commentDisabled"
                            rounded
                            @click.stop="storeComments()"
                            size="small"
                        >
                            Enregistrer les commentaires
                        </v-btn>
                    </v-card-text>
                </v-card-text>
            </v-card>

            <!-- ++ shortComment -->
            <v-card class="pa-6 mt-4">
                <v-row>
                    <!-- ** title ************** -->
                    <!-- <v-col cols="11" class="subtitle-2"> -->
                    <v-col cols="5" class="ma-auto">
                        <v-card-title class="ma-0 pa-0">
                            <h5 class="pl-4">Commentaires synthétiques</h5>
                        </v-card-title>
                    </v-col>

                    <v-spacer />

                    <!-- ** icons *************** -->
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-row>
                            <v-col cols="6" class="align-center pa-0">
                                <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                            </v-col>

                            <!-- ** expand icon -->
                            <v-col cols="6" class="align-center pa-0">
                                <v-btn-icon
                                    :icon="
                                        shortCommentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                    "
                                    data-cy="CheckFixedAssetsCutPrevious-commentairesSynthetiques"
                                    @click="shortCommentExpand = !shortCommentExpand"
                                    style="width: 40px"
                                    class="d-inline px-2"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-card-text v-if="shortCommentExpand" transition="shortCommentExpand">
                    <v-card-text class="px-4">
                        <v-textarea
                            v-model="shortComment"
                            :disabled="commentDisabled"
                            auto-grow
                            style="border: 1px #ededed solid"
                            outlined
                        />
                    </v-card-text>

                    <v-card-text class="text-end">
                        <!-- ** Store data -->
                        <v-btn
                            :disabled="commentDisabled"
                            rounded
                            @click.stop="storeComments()"
                            size="small"
                        >
                            Enregistrer les commentaires
                        </v-btn>
                    </v-card-text>
                </v-card-text>
            </v-card>

            <Chat
                :auditCheckAccountingPeriodKey="chatId"
                v-if="openChat"
                v-bind:chatTitle="'Chat'"
            />

            <AuditCheckDocumentsManager
                v-model="dialogAuditCheckDocumentsManager"
                v-if="dialogAuditCheckDocumentsManager"
                :disabled="loading || dataLoading"
                :companyId="companyId"
                :documentToDisplay="documentToDisplay"
                :connectedDocuments="connectedDocuments || []"
                :acKey="acKey"
                :auditCheckResult="auditCheckResult || {}"
                :accountingPeriodId="accountingPeriodId || undefined"
                :alreadyLinkedDoc="alreadyLinkedDoc"
                @upsertedAuditCheckResult="upsertedACR"
                @resetDialogData="
                    alreadyLinkedDoc = false;
                    documentToDisplay = {};
                "
            />

            <!-- ++ displayActivityDialog -->
            <oss-dialog
                v-model="displayActivityDialog"
                v-if="displayActivityDialog"
                title="Activité"
                valid-title="Fermer"
                @valid="displayActivityDialog = false"
                @close="displayActivityDialog = false"
                min-width="60vw"
            >
                <UsersActivitiesHistory
                    :auditCheckKey="acKey"
                    :accountingPeriodId="accountingPeriodId"
                >
                </UsersActivitiesHistory>
            </oss-dialog>

            <!-- ++ deleteAuditCheckResultDialog -->
            <template v-if="deleteAuditCheckResultDialog">
                <AuditDeleteAuditCheckResultDialog
                    v-model="deleteAuditCheckResultDialog"
                    :auditCheckResultId="cutsACRId"
                    :nestedAuditCheckResults="depreciationAcrIds"
                    @closed="
                        deleteAuditCheckResultLoading = false;
                        deleteAuditCheckResultDialog = false;
                    "
                    @deletedAcr="deleteAcrDone"
                />
                <!-- deleteAuditCheckResultLoading="deleteAuditCheckResultLoading" -->
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { isEmpty, sumBy } from "lodash";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";

import { mathFix, isAccountingZero, checkAmount } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import {
    getAccountingClosingDate,
    getLastClosedAndFirstOpenAccountingPeriods,
} from "../../services/accountingPeriods";
import { getDBFormattedDate } from "../../services/dateServices";

import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";

import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT from "../../graphql/audit/UpsertAuditCheckResultConnectExistingDocument.gql";
import UPSERT_AUDIT_CHECK_RESULT_DOCUMENT from "../../graphql/audit/UpdateAuditCheckResultConnectedDocuments.gql";

import { Document_type, AuditCheckResult_status } from "../../../../types/types/indexTypes";

import { CheckBase } from "./CheckBase";
import GeneralLedger from "../GeneralLedger2.vue";
import UploadDocuments from "./../document/UploadDocuments.vue";
import GetEmptyDocumentsTable from "./GetEmptyDocumentsTable.vue";
import CheckFixedAssetsCutPreviousImport from "./CheckFixedAssetsCutPreviousImport.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import Chat from "../chat/Chat.vue";
import ossDataTable from "../ossComponents/ossDataTable2.vue";
import AuditDeleteAuditCheckResultDialog from "./AuditDeleteAuditCheckResultDialog.vue";

import { DialogAction } from "../../services/dialogAction";
import { getEmptyDocument } from "../../services/documentServices";
import { generateLocalSpread, closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";
// ** local function
import { getAuditConnectAccountableAccount } from "../../services/audit/AuditServices";
import { UploadUrlDocumentService } from "@/services/UploadUrlDocumentService";
import { vatRatesAudit } from "../../services/vatServices";
import { Component, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { DataForDocument } from "@/types/cutPrevious/dataForDocument.types";
import { FileUrlDoc } from "@/types/cutPrevious/fileUrlDoc.types";


@Component({
    components: {
        // AccountableAccountVue,
        GetEmptyDocumentsTable,
        GeneralLedger,
        UploadDocuments,
        CheckFixedAssetsCutPreviousImport,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
        ossDataTable,
        AuditDeleteAuditCheckResultDialog,
    },
    emits: ["onEdit"],
})
export class CheckFixedAssetsCutPrevious extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) documentId: string;

    // ** loadings
    alsToDepreciateLoopLoading: boolean = false;
    dataLoading: boolean = true;
    deleteAuditCheckResultLoading: boolean = false;
    generateNDocumentsAndDepreciationsLoading: boolean = false;
    generateFullDepreciatedLoading: boolean = false;
    importLoading: boolean = false;
    loading: boolean = true;
    storeCutsLoading: boolean = false;
    storeFixedAssetsLoading: boolean = false;

    // ** lengths
    als2ToDepreciateLength: number = 0; // ** for progress-linear counter

    // ** ACR
    auditCheckResultId: string = "";
    // auditCheckKeyCutPrevious: string = "DNF1E0OlRCAENoSwsZSt6ZdG"
    auditCheckKeyToDepreciate: string = "rIr4hG5NdQWyEnIXvhnYtmmm";
    // auditCheckResult:any = {}
    resultDocumentIdsToDelete: Array<any> = [];
    cutsACRId: string = "";
    currentAlAcrData: any = {};

    // ** Dialogs
    dialogAuditCheckDocumentsManager: boolean = false;
    dialog: boolean = false;
    importWizardDialog: boolean = false;
    cutDialog: boolean = false;
    dialogCarryForwardCut: boolean = false;
    dialogUploadDocument: boolean = false;
    displayActivityDialog: boolean = false;
    deleteAuditCheckResultDialog: boolean = false;
    changeAccountableAccountsGapsDialog: boolean = false;
    fullGapsDialog: boolean = false;
    gap68LOnRegulN_1ErrorsDialog: boolean = false;
    fullDepreciatedFixedAssetsDialog: boolean = false;
    someDecliningDepreciationErrorDialog: boolean = false;

    alIndex: number = 0;

    generateDepreciation: boolean = true;
    vatList: Array<any> = [];

    tableKey: number = 0;

    sumSelectedGaps: number = 0;
    gapToAffect: number = 0;

    longCommentExpand: boolean = false;
    shortCommentExpand: boolean = false;

    longComment: string = "";
    shortComment: string = "";

    auditCheckResult: any = null; // ** used by AuditCheckDocumentsManager, AuditConnectedAcrDocuments, AuditConnectedAcrResults

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    selectedDocumentId: string = "";
    objectType: string = "";

    // ** dates && periods
    inAccountingPeriod: any = {};
    lastClosedPeriodEnd: string = "";
    // startBusinessDate: string = ""
    // ** Needed to create only documents in open periods
    lastClosedAndFirstOpenAccountingPeriods: any = {};
    firstUnclosedPeriodEnd: string = "";
    firstUnclosedPeriod: any = {};

    documents: Array<any> = [];
    outflowDocuments: Array<any> = [];
    outflowDocumentsALs: Array<any> = [];
    outflowDocsIdsToDelete: Array<any> = [];

    filteredIAL: Array<any> = [];

    // original: any = {}

    dotAmoType: string = "Dot. Amos - ";

    depreciationType: string = "Linéaire";
    depreciationTypes: Array<any> = ["Linéaire", "Dégressif"];

    // linearAccountingLines: Array<any> = []
    // decliningAccountingLines: Array<any> = []
    // derogationAccountingLines: Array<any> = []
    // accountingLines: Array<any> = []
    // outflowAccountingLines: Array<any> = []
    reversal28: number = 0;
    reversal145: number = 0;

    // ** shows
    onlyShowTable: boolean = false;
    showGL2: boolean = false;
    showGL28: boolean = false;
    showGL145: boolean = false;
    showGL25: boolean = false;
    showGL26: boolean = false;
    showGL27: boolean = false;
    showCarryForwardCut: boolean = false;
    showGenerateTableBtn: boolean = true;
    showNm1_2: boolean = false;
    showNm1_28: boolean = false;
    showNm1_145: boolean = false;
    showNm1_25: boolean = false;
    showNm1_26: boolean = false;
    showNm1_27: boolean = false;

    // ** GeneralLedger
    refreshGeneralLedger2: number = 0;
    refreshGeneralLedger28: number = 0;
    refreshGeneralLedger145: number = 0;
    refreshGeneralLedger25: number = 0;
    refreshGeneralLedger26: number = 0;
    refreshGeneralLedger27: number = 0;
    alreadyLinkedDoc: boolean = false;
    disabledChangeFixedAssetsAccountableAccountGap: boolean = true;

    // ** other boolenas
    switch1: boolean = true;
    closureControl: boolean = false;

    // ** errors lists
    errorMessages: Array<any> = [];
    someDecliningDepreciationError: boolean = false;
    someDecliningDepreciationErrorMessage; // ** what is typescript format for html coming from back ?
    errorsOnFullDepreciatedFixedAssets: Array<any> = [];
    gap68LOnRegulN_1Errors: Array<any> = [];

    accountableAccountLinesSelected: Array<any> = [];

    storeAccountableAccounts: Array<any> = [];

    actions = {
        action: new DialogAction(),
    };

    errorsUploadDocument: Map<string, string[]> = new Map();

    beforeMount() {
        this._mounted();
        // ** Needs all accountingPeriods attibutes to create only documents in open periods
        this.searchAccountingPeriod();

        this.vatList = vatRatesAudit;

        // this.setActions() // ** same as in @Watch { immediate: true }

        // if (this.accountingPeriods?.length) {
        //     this.lastClosedAndFirstOpenAccountingPeriods = getLastClosedAndFirstOpenAccountingPeriods(this.accountingPeriods)
        // }

        if (this.$store?.state?.accountableAccountTable?.accountableAccounts) {
            this.storeAccountableAccounts =
                this.$store.state.accountableAccountTable?.accountableAccounts;
        }
    }

    @Watch("incompleteFECStep", { immediate: true }) // ** same as in mounted: execute one single time
    setActions() {
        if (this.actions?.action) {
            if (this.incompleteFECStep === "accountableAccountsList") {
                this.actions.action.display = true;
                this.actions.action.function = () => {
                    this.generateNFixedAssets();
                };
                this.actions.action.loading = this.generateNDocumentsAndDepreciationsLoading;
                this.actions.action.disabled = () => {
                    return this.gapToAffect !== 0;
                };
                this.actions.action.title = "Générer les régularisations sur N";
            } else if (this.incompleteFECStep === "fullDepreciatedFixedAssets") {
                this.actions.action.display = true;
                this.actions.action.function = () => {
                    this.generateNDepreciations();
                };
                this.actions.action.loading = this.generateFullDepreciatedLoading;
                // this.actions.action.disabled = () => { return this.disabledChangeFixedAssetsAccountableAccountGap };
                this.actions.action.title = "Générer les écritures de régularisation sur N";
            } else {
                this.actions.action.display = false;
            }
        }
    }

    @Watch("accountableAccountLinesSelected", { deep: true })
    onAccountableAccountLinesSelectedChanged() {
        this.sumSelectedGapsLines();
    }

    closeDialog() {
        if (this.generateNDocumentsAndDepreciationsLoading) {
            this.incompleteFECStep = "alert";
            this.generateNDocumentsAndDepreciationsLoading = false;
            // } else if (this.incompleteFECStep === "singleAccountableAccountGaps") {
            //     this.accountableAccountLinesSelected = [];
        }
        this.fullGapsDialog = false;
        this.gap68LOnRegulN_1ErrorsDialog = false;
        this.someDecliningDepreciationErrorDialog = false;
    }

    expandedAccountableAccounts: Array<any> = [];

    expandedAccAccountImportedLinesWithoutGl(accAccountName) {
        const groupObj = this.gapsStarts.find((obj) =>
            obj.permitted.some((root) => accAccountName.startsWith(root)),
        );
        const attribute =
            groupObj.attributes.linear?.aaName || groupObj.attributes.derogation?.aaName;

        const importedLines = this.gaps?.[groupObj.group]?.importLinesWithoutGl?.filter(
            (aa) => aa?.[attribute] === accAccountName,
        );

        return importedLines || [];
    }

    isAccAccountExpanded(accAccountName) {
        const index = this.expandedAccountableAccounts.findIndex(
            (eaa) => eaa.accAccountName === accAccountName,
        );
        return index !== -1;
    }

    addRemoveAccAccountExpanded(accAccountName, key) {
        // this.amountAttribute = key == "2" ? "alNetAmountSigned" : "depreciationAmountSigned"
        const index = this.expandedAccountableAccounts.findIndex(
            (aa) => aa.accAccountName === accAccountName,
        );
        if (index === -1) {
            this.expandedAccountableAccounts.push({
                accAccountName: accAccountName,
                accAccountImportedLinesWithoutGl: this.gaps[key].importLinesWithoutGl.filter(
                    (il) => il.aaNameFixedAsset === accAccountName,
                ),
            });
            this.sumSelectedGapsLines();
        } else {
            this.expandedAccountableAccounts.splice(index, 1);
        }
    }

    // ****************************************
    // ** AUDIT_ITEMS
    // auditItems: any = {}
    // company: any = {}

    // groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows: Array<any> = [];

    // cutAcrResultDocumentIdsToDelete: Array<string> = [];

    // previousAlIds: Array<string> = [];

    // als2ToCut: Array<any> = [];
    // als28ToCut: Array<any> = [];
    // als145ToCut: Array<any> = [];
    // alsToCut: Array<any> = [];

    // als2ToReconciliate: Array<any> = [];
    // als28ToReconciliate: Array<any> = [];
    // als145ToReconciliate: Array<any> = [];
    // alsToReconciliate: Array<any> = [];
    // alsToReconcilateIds: Array<string> = []

    // als2ToDepreciate: Array<any> = [];

    // AAs2: Array<string> = [];

    // AAs28: Array<string> = [];
    // AAs145: Array<string> = [];

    // gl2_total: number = 0
    // gl28_total: number = 0
    // gl145_total: number = 0
    // ****************************

    // ** receiving companyId from props
    // get selectedCompany() {
    //     return this.$store.state.selected_company;
    // }

    defaultSelectedDate =
        moment(this.$store?.state?.accountingPeriod?.selectedAccountingPeriod?.start)
            .clone()
            .add(-1, "days")
            .endOf("day")
            .format() || moment().endOf("day").format();

    N_1AccountingPeriod: any = {};

    selectedDate = "";

    showDeleteAcrBtnTooltipMessage: string = "";

    mathFix(number: number) {
        return mathFix(number, 2);
    }

    isEmpty(obj) {
        return isEmpty(obj);
    }

    // get currentUser():User {
    //     return this.$store.state.user;
    // }

    get checkStatus() {
        if (this.validated) {
            return "Validé";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        return "statut manquant";
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod); // ** true false
        }
        return false;
    }

    formatDate(date: string) {
        const returnedDate = moment(date).format("DD/MM/YYYY");
        return returnedDate;
    }

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, options);
    }

    getLastClosedAndFirstOpenAccountingPeriods(storeAccountingPeriods) {
        return getLastClosedAndFirstOpenAccountingPeriods(storeAccountingPeriods as any);
    }

    // ++++++++++++ depreciation table headers +++++++++
    depreciationHeaders: Array<any> = [
        {
            text: "Année",
            value: "resumePeriodEnd",
            align: "center",
            sortable: false,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
        },
        {
            text: "L - VNC début",
            value: "linearNetBookValue0101",
            align: "end",
            sortable: false,
        },
        {
            text: "L - cumul N-1",
            value: "linearAccumulatedDepreciationStart",
            align: "end",
            sortable: false,
        },
        {
            text: "L - Dot.",
            value: "linearYearDepreciation",
            align: "end",
            sortable: false,
        },
        {
            text: "L - Cumul N",
            value: "linearAccumulatedDepreciation",
            align: "end",
            sortable: false,
        },
        {
            text: "L - VNC Fin",
            value: "linearNetBookValue3112",
            align: "end",
            sortable: false,
            style: "border-end:1px solid #dddddd;",
        },
        {
            text: "D - VNC 01-01",
            value: "decliningNetBookValue0101",
            align: "end",
            sortable: false,
        },
        {
            text: "D - cumul N-1",
            value: "decliningAccumulatedDepreciationStart",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
        {
            text: "D - Dot.",
            value: "decliningYearDepreciation",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
        {
            text: "D - Cumul",
            value: "decliningAccumulatedDepreciation",
            align: "end",
            sortable: false,
        },
        {
            text: "D - VNC 31-12",
            value: "decliningNetBookValue3112",
            align: "end",
            sortable: false,
            style: "border-end:1px solid #dddddd;",
        },
        {
            text: "Dot. dérogatoire",
            value: "derogationYearDepreciation",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
    ];

    singleSelect: boolean = false;

    selectedGapAccAccountImportedLinesHea: Array<any> = [
        {
            title: "",
            key: "checkbox",
            width: "64px",
            sortable: false,
        },
        {
            title: "Déscription",
            key: "wording",
            align: "start",
            sortable: true,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
            width: "auto",
        },
        {
            title: "Date",
            key: "date",
            align: "start",
            sortable: true,
            width: "120px",
        },
        {
            title: "Mode",
            key: "type",
            align: "start",
            sortable: false,
            width: "120px",
        },
        {
            title: "%",
            key: "rate",
            align: "start",
            sortable: false,
            width: "120px",
        },
        {
            title: "Prix d'acquisition",
            key: "alNetAmountSigned",
            align: "end",
            sortable: true,
            width: "120px",
        },
        {
            title: "Cumul N-1",
            key: "previousDepreciationAmountSigned",
            align: "end",
            sortable: true,
            width: "120px",
        },
    ];

    fullDepreciatedFixedAssetsHeaders: Array<any> = [
        {
            title: "Date achat",
            value: "date",
            align: "start",
            sortable: true,
            width: "auto",
        },
        {
            title: "Compte immo",
            value: "aaName",
            align: "start",
            sortable: true,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
            width: "auto",
        },
        {
            title: "Compte amo",
            value: "aaDepreciationName",
            align: "start",
            sortable: true,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
            width: "auto",
        },
        {
            title: "Déscription",
            value: "wording",
            align: "start",
            sortable: true,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
            width: "auto",
        },
        // {
        //     title: "Mode",
        //     value: "type",
        //     align: "start",
        //     sortable: false,
        //     width: "120px",
        // },
        // {
        //     title: "%",
        //     value: "rate",
        //     align: "start",
        //     sortable: false,
        //     width: "120px",
        // },

        {
            title: "Date fin amo",
            value: "linearSpreadEndDate",
            align: "start",
            sortable: true,
            width: "120px",
        },
        {
            title: "Prix d'acquisition",
            value: "alNetAmountSigned",
            align: "end",
            sortable: true,
            width: "120px",
        },
        {
            title: "Cumul amos importé",
            value: "importedPreviousDepreciationAmountSigned",
            align: "end",
            sortable: true,
            width: "120px",
        },
        // {
        //     title: "Cumul amos calculé",
        //     value: "calculatedPreviousDepreciationAmountSigned",
        //     align: "end",
        //     sortable: true,
        //     width: "120px",
        // },
        {
            title: "Ecart immo/amos",
            value: "gap",
            align: "end",
            sortable: true,
            width: "120px",
        },
    ];

    gapsGlWithoutImportsHeaders: Array<any> = [
        {
            title: "Compte immo",
            value: "aaName",
            align: "start",
            // sortable: true,
            // width: "120px",
        },
        {
            title: "Ecart",
            value: "gap",
            align: "end",
            // sortable: true,
            // width: "120px",
        },
    ];

    gapsGlHeaders: Array<any> = [
        {
            title: "Compte immo",
            value: "aaName",
            align: "start",
            // sortable: true,
            // width: "120px",
        },
        {
            title: "Solde GL",
            value: "glSum",
            align: "end",
            // sortable: true,
            // width: "120px",
        },
        {
            title: "Solde imports réconnus",
            value: "alreadyImportedSum",
            align: "end",
            // sortable: true,
            // width: "120px",
        },
        {
            title: "Solde régul imports",
            value: "importedSum",
            align: "end",
            // sortable: true,
            // width: "120px",
        },
        {
            title: "Ecart",
            value: "gap",
            align: "end",
            // sortable: true,
            // style: "font-weight: bold; border-end:1px solid #dddddd;",
            // width: "auto"
        },
    ];

    gapsImportedLinesHeaders2: Array<any> = [
        {
            title: "Compte immo",
            value: "aaNameFixedAsset",
            align: "start",
            sortable: true,
            width: "120px",
        },
        {
            title: "Nouveau compte",
            value: "changedAccountableAccount",
            align: "end",
            sortable: true,
            width: "120px",
        },
        {
            title: "Compte amo",
            value: "aaNameDepreciation",
            align: "start",
            sortable: true,
            width: "120px",
        },
        {
            title: "Date",
            value: "date",
            align: "start",
            sortable: true,
            width: "120px",
        },
        {
            title: "Déscription",
            value: "wording",
            align: "start",
            sortable: true,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
            width: "auto",
        },
        {
            title: "Mode",
            value: "type",
            align: "start",
            sortable: false,
            width: "120px",
        },
        {
            title: "%",
            value: "rate",
            align: "start",
            sortable: false,
            width: "120px",
        },
        {
            title: "Prix d'acquisition",
            value: "alNetAmountSigned",
            align: "end",
            sortable: true,
            width: "120px",
        },
        {
            title: "Cumul N-1",
            value: "previousDepreciationAmountSigned",
            align: "end",
            sortable: true,
            width: "120px",
        },
        // {
        //     title: "Dot. dérogatoire",
        //     value: "derogationYearDepreciation",
        //     align: "end",
        //     sortable: true,
        //     width: "120px",
        // }
    ];

    gapsImportedLinesHeaders28: Array<any> = [
        {
            title: "Compte immo",
            value: "aaNameFixedAsset",
            align: "start",
            sortable: true,
            width: "120px",
        },
        {
            title: "Compte amo",
            value: "aaNameDepreciation",
            align: "start",
            sortable: true,
            width: "120px",
        },
        {
            title: "Nouveau compte",
            value: "changedAccountableAccount",
            align: "end",
            sortable: true,
            width: "120px",
        },
        {
            title: "Date",
            value: "date",
            align: "start",
            sortable: true,
            width: "120px",
        },
        {
            title: "Déscription",
            value: "wording",
            align: "start",
            sortable: true,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
            width: "auto",
        },
        {
            title: "Mode",
            value: "type",
            align: "start",
            sortable: false,
            width: "120px",
        },
        {
            title: "%",
            value: "rate",
            align: "start",
            sortable: false,
            width: "120px",
        },
        {
            title: "Prix d'acquisition",
            value: "alNetAmountSigned",
            align: "end",
            sortable: true,
            width: "120px",
        },
        {
            title: "Cumul N-1",
            value: "previousDepreciationAmountSigned",
            align: "end",
            sortable: true,
            width: "120px",
        },
        // {
        //     title: "Dot. dérogatoire",
        //     value: "derogationYearDepreciation",
        //     align: "end",
        //     sortable: true,
        //     width: "120px",
        // }
    ];

    gap68OnRegulN_1ErrorsHeaders: Array<any> = [
        // regul68Gap: regul68Gap,
        // wording: currentAlAcrData.fixedAssetWording,
        // accountableAccount: aLObject6811.accountableAccount.connect.uniqueName.name,
        // // add previousDepreciationAmountSigned from file
        // // add calculated full year previousDepreciationAmountSigned
        {
            title: "c/immo",
            key: "accountableAccount",
            align: "start",
            sortable: true,
            width: "70px",
        },
        {
            title: "Description",
            key: "wording",
            align: "start",
            sortable: true,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
            width: "auto",
        },
        {
            title: "Date achat",
            key: "date",
            align: "center",
            sortable: true,
            width: "90px",
        },
        {
            title: "Durée",
            key: "selectedYearDuration",
            align: "center",
            sortable: true,
            width: "50px",
        },
        {
            title: "Prix d'achat H.T.",
            key: "alNetAmountSigned",
            align: "end",
            sortable: true,
            width: "90px",
        },
        {
            title: "Cumul amos",
            align: "center",
            children: [
                {
                    title: "Importé",
                    key: "previousDepreciationAmountSigned",
                    align: "end",
                    sortable: true,
                    width: "90px",
                },
                {
                    title: "Calculé",
                    key: "calculatedSumAmount",
                    align: "end",
                    sortable: true,
                    width: "90px",
                },
            ],
        },
        {
            title: "Écart",
            key: "regul68Gap",
            align: "center",
            sortable: true,
            width: "90px",
        },
        {
            title: "Mise en service",
            align: "center",
            children: [
                {
                    title: "Calculée (proposée)",
                    key: "suggestedDate",
                    align: "end",
                    sortable: true,
                    width: "90px",
                },
                {
                    title: "Appliquée",
                    key: "linearSpreadStartDate",
                    align: "center",
                    sortable: true,
                    width: "170px",
                },
            ],
        },
    ];

    fixedAssetsFile: Array<any> = [];

    afterAccountingPeriodFound() {}

    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.dataLoading = true;
                    if (data?.auditItems?.items?.[0]) {
                        this.company = {};
                        this.cutsACRId = "";
                        this.cutsACR = {};
                        this.depreciationAcrIds = [];
                        this.companyFirstPeriod = {};
                        this.currentPeriodIsFirstPeriod = false;
                        this.noData = false;
                        this.reviewed = 0;
                        this.validated = false;
                        this.connectedDocuments = [];
                        // this.wrongAaPairs = []
                        // this.notInBobbeeAccountableAccounts = {}
                        // this.fixedAssetsFileLinesAssigned = []
                        this.results = [];
                        this.cutAcrResultDocumentIdsToDelete = [];
                        this.longComment = "";
                        this.shortComment = "";
                        this.fixedAssetsFile = [];
                        this.recoveryFinished = false;
                        this.lastSituationDateYYYYMMDD = "";
                        this.N_1AccountingPeriod = {};
                        this.selectedDate = "";
                        this.lastClosedAndFirstOpenAccountingPeriods = {};
                        this.als2ToCut = [];
                        this.als2NotFromCarryForwardSum = 0;
                        this.als28ToCut = [];
                        this.als28NotFromCarryForwardSum = 0;
                        this.als145ToCut = [];
                        this.als145NotFromCarryForwardSum = 0;
                        this.als26ToCut = [];
                        this.als26NotFromCarryForwardSum = 0;
                        this.als27ToCut = [];
                        this.als27NotFromCarryForwardSum = 0;
                        this.alsToCut = [];
                        this.alsToReconciliateSum = 0;
                        this.gaps = {};
                        this.gap2 = 0;
                        this.gap28 = 0;
                        this.gap145 = 0;
                        this.gap26 = 0;
                        this.gap27 = 0;
                        this.als2ToDepreciate = [];
                        this.als2ToDepreciateLength = 0;
                        this.stepCount = 0;
                        this.depreciationAcrIds = [];

                        this.gl2_total = 0;
                        this.gl28_total = 0;
                        this.gl145_total = 0;
                        this.gl25_total = 0;
                        this.gl26_total = 0;
                        this.gl27_total = 0;

                        this.gl2_total_filtered = 0;
                        this.gl28_total_filtered = 0;
                        this.gl145_total_filtered = 0;
                        this.gl26_total_filtered = 0;
                        this.gl27_total_filtered = 0;

                        this.generateNDocumentsAndDepreciationsLoading = false; // ** to change if this.gaps.length
                        this.deleteAuditCheckResultLoading = false;
                        this.importLoading = false;
                        this.storeFixedAssetsLoading = false;
                        this.storeCutsLoading = false;
                        this.cutDialog = false;
                        this.fullGapsDialog = false;
                        this.deleteAuditCheckResultDialog = false;
                        this.fullDepreciatedFixedAssetsDialog = false;
                        this.cutDocument = undefined;
                        this.someDecliningDepreciationError = false;
                        this.gap68LOnRegulN_1Errors = [];
                        this.selectedFullGapsLines = [];
                        this.sumSelectedGaps = 0;
                        this.gapToAffect = 0;
                        this.changeFixedAssetsAccountableAccountGap = false;
                        this.changeDepreciationAccountableAccountGap = false;
                        this.changeDerogationAccountableAccountGap = false;
                        this.gap_fixedAssetsAccountableAccount = null;
                        this.gap_depreciationAccountableAccount = null;
                        this.gap_derogationAccountableAccount = null;
                        this.adjustDocumentsOnFullDepreciatedFixedAssets = [];

                        this.auditItems = JSON.parse(JSON.stringify(data.auditItems.items[0]));

                        // retrieve errorsUploadDocument from auditItems.cutsACR.data.errorsUploadDocument
                        this.errorsUploadDocument.clear();
                        if(this.auditItems.cutsACR?.data?.errorsUploadDocument) {
                            this.auditItems.cutsACR?.data?.errorsUploadDocument.forEach(obj => {
                                this.errorsUploadDocument.set(obj.error, obj.fixedAssets);
                            });
                        }

                        if (this.auditItems) {
                            this.company = this.auditItems.company || {};
                            this.cutsACRId = this.auditItems.cutsACR?.id || "";
                            this.cutsACR = this.auditItems.cutsACR || {};
                            this.depreciationAcrIds = this.auditItems.depreciationAcrIds || [];
                            this.companyFirstPeriod = this.auditItems.companyFirstPeriod || {};

                            this.currentPeriodIsFirstPeriod =
                                this.auditItems.currentPeriodIsFirstPeriod || false;
                            this.noData = this.auditItems.noData || false;

                            if (
                                !this.cutsACRId &&
                                (this.currentPeriodIsFirstPeriod || this.noData)
                            ) {
                                this.storeComments();
                            }

                            this.reviewed = this.cutsACR?.reviewed || 0;

                            this.validated = this.cutsACR?.data?.validated || false;

                            if (!isEmpty(this.cutsACR)) {
                                this.gapsStarts = this.auditItems.gapsStarts;
                                this.auditCheckResult = this.cutsACR;

                                this.cutsACRId = this.cutsACR.id;

                                this.connectedDocuments = this.cutsACR.documents?.length
                                    ? this.cutsACR.documents
                                    : [];

                                this.results = this.cutsACR.results?.length
                                    ? this.cutsACR.results
                                    : [];

                                // ** delete only "normal" cut result
                                // ** keep notInFECDocuments results
                                this.cutAcrResultDocumentIdsToDelete =
                                    this.auditItems.cutAcrResultDocumentIdsToDelete || [];

                                this.notInFECDocuments = this.auditItems.notInFECDocuments || [];
                                this.adjustDocumentsOnFullDepreciatedFixedAssets =
                                    this.auditItems.adjustDocumentsOnFullDepreciatedFixedAssets ||
                                    [];
                                this.cutDocument = this.auditItems.cutDocument || {};

                                if (this.cutsACR.data) {
                                    this.longComment = this.cutsACR.data.longComment || "";
                                    this.shortComment = this.cutsACR.data.shortComment || "";
                                    this.fixedAssetsFile = this.cutsACR.data.fixedAssetsFile || [];

                                    if (this.cutsACR.data?.recoveryFinished) {
                                        this.recoveryFinished = true;
                                    }
                                }
                            }

                            if (!this.noData && !this.currentPeriodIsFirstPeriod) {
                                if (this.auditItems.lastSituationDateYYYYMMDD) {
                                    this.lastSituationDateYYYYMMDD =
                                        this.auditItems.lastSituationDateYYYYMMDD;
                                }

                                if (!this.recoveryFinished) {
                                    this.someDecliningDepreciationError =
                                        this.auditItems.someDecliningDepreciationError;
                                    this.someDecliningDepreciationErrorMessage = this
                                        .someDecliningDepreciationError
                                        ? this.auditItems.someDecliningDepreciationErrorMessage ||
                                          "Pas d'erreur ?"
                                        : "";
                                    this.someDecliningDepreciationErrorDialog =
                                        this.someDecliningDepreciationError;

                                    this.N_1AccountingPeriod =
                                        this.auditItems.N_1AccountingPeriod || null;
                                    this.selectedDate = this.formatDatePicker(
                                        this.auditItems.selectedDate,
                                    );
                                    this.lastClosedAndFirstOpenAccountingPeriods =
                                        this.auditItems.lastClosedAndFirstOpenAccountingPeriods;

                                    // ** complete generalLedger total
                                    this.gl2_total = this.auditItems.gl2_total || 0;
                                    this.gl28_total = this.auditItems.gl28_total || 0;
                                    this.gl145_total = this.auditItems.gl145_total || 0;
                                    this.gl25_total = this.auditItems.gl25_total || 0;
                                    this.gl26_total = this.auditItems.gl26_total || 0;
                                    this.gl27_total = this.auditItems.gl27_total || 0;

                                    // ** filter only to cut generalLedger total
                                    this.gl2_total_filtered =
                                        this.auditItems.gl2_total_filtered || 0;
                                    this.gl28_total_filtered =
                                        this.auditItems.gl28_total_filtered || 0;
                                    this.gl145_total_filtered =
                                        this.auditItems.gl145_total_filtered || 0;
                                    this.gl25_total_filtered =
                                        this.auditItems.gl25_total_filtered || 0;
                                    this.gl26_total_filtered =
                                        this.auditItems.gl26_total_filtered || 0;
                                    this.gl27_total_filtered =
                                        this.auditItems.gl27_total_filtered || 0;

                                    this.gaps = this.auditItems.gaps || {};

                                    if (!isEmpty(this.gaps) && this.fixedAssetsFile?.length) {
                                        this.gap2 = this.gaps["2"] || 0;
                                        this.gap28 = this.gaps["28"] || 0;
                                        this.gap145 = this.gaps["145"] || 0;
                                        this.gap25 = this.gaps["25"] || 0;
                                        this.gap26 = this.gaps["26"] || 0;
                                        this.gap27 = this.gaps["27"] || 0;

                                        // ** if some gap exists wich sumGap is null,
                                        // ** we have to resolve it in changeAccountableAccountsGapsDialog
                                        // ** before to generate documents and depreciations in fullGapsDialog
                                        // ** before to generate documents and depreciations in gapsBetweenImportAndGLDialog
                                        if (this.auditItems.fullGapsDialog) {
                                            this.amountAttribute =
                                                Object.keys(this.gaps)?.[0] === "2"
                                                    ? "alNetAmountSigned"
                                                    : "depreciationAmountSigned";
                                            this.gapToAffect =
                                                this.gaps?.["2"]?.sumGap ||
                                                this.gaps?.["28"]?.sumGap ||
                                                0;

                                            this.incompleteFECStep =
                                                this.gaps?.["2"]?.glWithoutImportResume?.length ||
                                                this.gaps?.["28"]?.glWithoutImportResume?.length
                                                    ? "alert"
                                                    : "accountableAccountsList";

                                            this.gap_fixedAssetsAccountableAccount =
                                                this.auditItems.gap_fixedAssetsAccountableAccount ||
                                                null;
                                            this.gap_depreciationAccountableAccount =
                                                this.auditItems
                                                    .gap_depreciationAccountableAccount || null;
                                            this.gap_derogationAccountableAccount =
                                                this.auditItems.gap_derogationAccountableAccount ||
                                                null;

                                            this.fullGapsDialog = true;
                                        } else if (
                                            this.auditItems.changeAccountableAccountsGapsDialog
                                        ) {
                                            this.changeFixedAssetsAccountableAccountGap =
                                                this.auditItems
                                                    .changeFixedAssetsAccountableAccountGap ||
                                                false;
                                            this.changeDepreciationAccountableAccountGap =
                                                this.auditItems
                                                    .changeDepreciationAccountableAccountGap ||
                                                false;
                                            this.changeDerogationAccountableAccountGap =
                                                this.auditItems
                                                    .changeDerogationAccountableAccountGap || false;

                                            this.gap_fixedAssetsAccountableAccount =
                                                this.auditItems.gap_fixedAssetsAccountableAccount ||
                                                null;
                                            this.gap_depreciationAccountableAccount =
                                                this.auditItems
                                                    .gap_depreciationAccountableAccount || null;
                                            this.gap_derogationAccountableAccount =
                                                this.auditItems.gap_derogationAccountableAccount ||
                                                null;

                                            this.changeAccountableAccountsGapStep = "changeAAList";
                                            this.changeAccountableAccountsGapsDialog = true;
                                        } else {
                                            console.error(
                                                "this.gaps is not empty but no dialog is open",
                                            );
                                            debugger;
                                        }
                                    } else if (this.auditItems.fullDepreciatedFixedAssetsDialog) {
                                        this.incompleteFECStep = "fullDepreciatedFixedAssets";
                                    } else {
                                        if (this.auditItems.alsToReconciliateSum) {
                                            this.alsToReconciliateSum =
                                                this.auditItems.alsToReconciliateSum;
                                            // // to comment
                                            // this.als2ToReconciliate = this.auditItems.als2ToReconciliate || []
                                            // this.als28ToReconciliate = this.auditItems.als28ToReconciliate || []
                                            // this.als145ToReconciliate = this.auditItems.als145ToReconciliate || []
                                            // this.alsToReconciliate = [...this.als2ToReconciliate, ...this.als28ToReconciliate || null, ...this.als145ToReconciliate || null]
                                            // this.alsToReconcilateIds = this.alsToReconciliate.map(atr => atr.id)
                                            // ///////
                                        } else if (this.auditItems.als2ToCut?.length) {
                                            this.als2ToCut = this.auditItems.als2ToCut || [];
                                            if (this.auditItems.updatedFixedAssetsFile.length) {
                                                if (
                                                    this.auditItems.updatedFixedAssetsFile.length >
                                                    this.fixedAssetsFile.length
                                                ) {
                                                    console.error(
                                                        "🚀 - specificResult - this.fixedAssetsFile.length:",
                                                        this.fixedAssetsFile.length,
                                                    );
                                                    console.error(
                                                        "🚀 - specificResult - this.auditItems.updatedFixedAssetsFile.length:",
                                                        this.auditItems.updatedFixedAssetsFile
                                                            .length,
                                                    );
                                                    console.error(
                                                        "this.auditItems.updatedFixedAssetsFile.length != this.fixedAssetsFile.length",
                                                    );
                                                    debugger;
                                                }
                                                this.fixedAssetsFile =
                                                    this.auditItems.updatedFixedAssetsFile;
                                            }
                                            // if (this.als2ToCut.length && this.auditItems.netOfNotInFecFixedAssetsFile?.length) {
                                            //     if (this.auditItems.netOfNotInFecFixedAssetsFile?.length > this.fixedAssetsFile?.length) {
                                            //         console.error("this.auditItems.netOfNotInFecFixedAssetsFile?.length > this.fixedAssetsFile?.length")
                                            //         debugger
                                            //     }
                                            //         this.fixedAssetsFile = this.auditItems.netOfNotInFecFixedAssetsFile
                                            // }
                                            this.als2NotFromCarryForwardSum =
                                                this.auditItems.als2NotFromCarryForwardSum || 0;
                                            this.als28ToCut = this.auditItems.als28ToCut || [];
                                            this.als28NotFromCarryForwardSum =
                                                this.auditItems.als28NotFromCarryForwardSum || 0;
                                            this.als145ToCut = this.auditItems.als145ToCut || [];
                                            this.als145NotFromCarryForwardSum =
                                                this.auditItems.als145NotFromCarryForwardSum || 0;
                                            this.als26ToCut = this.auditItems.als26ToCut || [];
                                            this.als26NotFromCarryForwardSum =
                                                this.auditItems.als26NotFromCarryForwardSum || 0;
                                            this.als27ToCut = this.auditItems.als27ToCut || [];
                                            this.als27NotFromCarryForwardSum =
                                                this.auditItems.als27NotFromCarryForwardSum || 0;
                                            this.alsToCut = [
                                                ...this.als2ToCut,
                                                ...(this.als28ToCut || null),
                                                ...(this.als145ToCut || null),
                                                ...(this.als26ToCut || null),
                                                ...(this.als27ToCut || null),
                                            ];
                                        } else if (this.auditItems.als2ToDepreciate?.length) {
                                            this.als2ToDepreciate =
                                                this.auditItems.als2ToDepreciate || [];

                                            this.als2ToDepreciateLength = JSON.parse(
                                                JSON.stringify(
                                                    this.auditItems.als2ToDepreciate?.length || 0,
                                                ),
                                            ); // ** for progress-linear counter
                                            this.stepCount = JSON.parse(
                                                JSON.stringify(
                                                    this.auditItems.als2ToDepreciate || [],
                                                ),
                                            );

                                            this.depreciationAcrIds =
                                                this.auditItems.depreciationAcrIds || [];
                                        }
                                        // ** variables for fullGapsDialog are keeped or emptied here
                                        // ** variables for gapsBetweenImportAndGLDialog are keeped or emptied here
                                    }

                                    // /////////////// declarationAccountingLines ////////
                                    // if (this.auditItems.declarationAccountingLines) {
                                    //     this.declarationAccountingLines = this.auditItems.declarationAccountingLines
                                    // }
                                    // ///////////////////////////////////////////////////

                                    // this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows = this.auditItems.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows || {}
                                }
                            }
                        }
                    }
                    this.dataLoading = false;
                }
                this.loading = loading;
            }
        },
    })
    auditItems: any = {};

    gapsStarts: Array<any> = [];

    noData: boolean = false;
    currentPeriodIsFirstPeriod = false;

    // noDataValidated = false
    reviewed: number = 0;

    company: any = {};

    // wrongAaPairs: Array<any> = []

    // notInBobbeeAccountableAccounts: any = {}

    // groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows: Array<any> = [];

    cutAcrResultDocumentIdsToDelete: Array<string> = [];
    notInFECDocuments: Array<any> = [];
    adjustDocumentsOnFullDepreciatedFixedAssets: Array<any> = [];
    cutDocument: any = {};

    // previousAlIds: Array<string> = [];

    gaps: any = {};

    // fixedAssetsFileLinesAssigned: Array<any> = []

    als2ToCut: Array<any> = [];
    als2NotFromCarryForwardSum: number = 0;
    als28ToCut: Array<any> = [];
    als28NotFromCarryForwardSum: number = 0;
    als145ToCut: Array<any> = [];
    als145NotFromCarryForwardSum: number = 0;
    als26ToCut: Array<any> = [];
    als26NotFromCarryForwardSum: number = 0;
    als27ToCut: Array<any> = [];
    als27NotFromCarryForwardSum: number = 0;
    alsToCut: Array<any> = [];
    recoveryFinished: boolean = false;

    // // to comment
    // als2ToReconciliate: Array<any> = [];
    // als28ToReconciliate: Array<any> = [];
    // als145ToReconciliate: Array<any> = [];
    // als26ToReconciliate: Array<any> = [];
    // als27ToReconciliate: Array<any> = [];
    // alsToReconciliate: Array<any> = [];
    // alsToReconcilateIds: Array<string> = []
    // ///////////////
    alsToReconciliateSum: number = 0;

    als2ToDepreciate: Array<any> = [];
    stepCount: number = 0;

    depreciationAcrIds: Array<any> = [];

    gl2_total: number = 0;
    gl28_total: number = 0;
    gl145_total: number = 0;
    gl25_total: number = 0;
    gl26_total: number = 0;
    gl27_total: number = 0;

    gl2_total_filtered: number = 0;
    gl28_total_filtered: number = 0;
    gl145_total_filtered: number = 0;
    gl25_total_filtered: number = 0;
    gl26_total_filtered: number = 0;
    gl27_total_filtered: number = 0;

    lastSituationDateYYYYMMDD: string = undefined;

    cutsACR: any = {};

    validated: boolean = false;

    // ************ V-WINDOW **************
    step: string = "";
    incompleteFECStep: string = "default";
    changeAccountableAccountsGapStep: string = "default";

    companyFirstPeriod: any = {};

    changeFixedAssetsAccountableAccountGap: boolean = false;

    changeDepreciationAccountableAccountGap: boolean = false;

    changeDerogationAccountableAccountGap: boolean = false;

    gap_fixedAssetsAccountableAccount: any = null;

    gap_depreciationAccountableAccount: any = null;

    gap_derogationAccountableAccount: any = null;

    get currentTitle() {
        switch (this.step) {
            case "generateDepreciationStep":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Saisie des éléments`
                    : "Saisie des éléments";
            case "outflowStep":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Sortie de l'immobilisation`
                    : "Sortie de l'immobilisation";
            case "tableStep":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Détail de l'immobilisation`
                    : "Détail de l'immobilisation";
            default:
                return `Détail de l'immobilisation`;
        }
    }

    get currentCarryForwardCutTitle() {
        switch (this.step) {
            case "singleOrMultipleChoice":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Saisie des éléments`
                    : "Saisie des éléments";
            case "outflowStep":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Sortie de l'immobilisation`
                    : "Sortie de l'immobilisation";
            case "tableStep":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Détail de l'immobilisation`
                    : "Détail de l'immobilisation";
            default:
                return `Détail de l'immobilisation`;
        }
    }

    quitDialog() {
        this.dialog = false;
        // this.importWizardDialog = false
        this.generateDepreciation = true;
        // this.original = {}
        this.documents = [];
        this.cutAcrResultDocumentIdsToDelete = [];
        this.currentAlAcrData = {};
        this.onlyShowTable = false;
        this.dotAmoType = "Dot. Amos - ";
        this.step = "";
        this.selectedDocumentId = "";
        this.objectType = "";
        this.inAccountingPeriod = {};
        this.showGenerateTableBtn = true;
        this.switch1 = true;
        this.closureControl = false;
        // this.startBusinessDate = ""
    }

    async openCarryForwardCutDialog(carryForward) {
        this.showCarryForwardCut = true;
    }

    selectedGapAccAccount: any = {};
    amountAttribute: string = "";
    accAccountImportedLinesWithoutGl: Array<any> = [];

    // openFullGapsDetails(accAccount, key) {
    //     this.accAccountImportedLinesWithoutGl = this.gaps[key].importLinesWithoutGl.filter(il => il.aaNameFixedAsset === accAccount.aaName)
    //     this.amountAttribute = key == "2" ? "alNetAmountSigned" : "depreciationAmountSigned"
    //     this.sumSelectedGapsLines()
    //     this.incompleteFECStep = 'singleAccountableAccountGaps'
    // }

    // **************** OPEN DIALOG *****************
    // async openDialog(data2) {   // ** props.item = {
    //                             // **    currentAlAcrData: {},
    //                             // ** }
    //     this.selectedDocumentId = data2.currentAlAcrData.documentId
    //     this.objectType = data2.currentAlAcrData.objectType
    //     this.dialog = true

    //     if (!this.inAccountingPeriod || !this.inAccountingPeriod.end) {
    //         this.currentAlAcrData = data2.currentAlAcrData
    //         this.setInAccountingPeriod()
    //     }

    //     if (this.onlyShowTable && data2.currentAlAcrData && data2.currentAlAcrData.depreciationTable && data2.currentAlAcrData.depreciationTable.length) {
    //         this.currentAlAcrData = data2.currentAlAcrData
    //         this.step = 'table'
    //     } else {
    //         let currentAlAcrData: any = JSON.parse(JSON.stringify(data2.currentAlAcrData))

    //         this.depreciationType = currentAlAcrData.linearDepreciation ? this.depreciationTypes[0] : this.depreciationTypes[1]

    //         if (!currentAlAcrData.yearDuration || !Object.keys(currentAlAcrData.yearDuration).length) {
    //             if (currentAlAcrData.accountableAccount && currentAlAcrData.accountableAccount.name) {
    //                 currentAlAcrData.yearDuration = currentAlAcrData.yearDuration || getDepreciationDurations().find(dr => dr.name === currentAlAcrData.accountableAccount.name)

    //                 currentAlAcrData.selectedYearDuration = currentAlAcrData.selectedYearDuration ? currentAlAcrData.selectedYearDuration :

    //                 currentAlAcrData.yearDuration.defaultYearDuration ? currentAlAcrData.yearDuration.defaultYearDuration : 0
    //             }
    //         }

    //         this.currentAlAcrData = currentAlAcrData
    //         // this.currentDocAcrData[currentAlAcrData.currentAlIndex] = currentAlAcrData
    //     }
    // }

    async alsToDepreciateLoop() {
        this.cutDocument = undefined;
        this.alIndex = 0;

        let upsertVariablesDico = [];
        this.errorsOnFullDepreciatedFixedAssets = [];

        if (this.als2ToDepreciate?.length) {
            this.alsToDepreciateLoopLoading = true;

            for (const al of this.als2ToDepreciate) {
                // eslint-disable-next-line no-await-in-loop
                const localSpread: any = await generateLocalSpread(
                    this.$apollo,
                    this.$store,
                    al.al2.currentAlAcrData,
                    this.lastClosedAndFirstOpenAccountingPeriods,
                    this.currentUser?.id,
                    true, // ** fromCutPrevious = true
                    this.company,
                    this.accountingPeriod,
                    this.lastSituationDateYYYYMMDD,
                );

                if (localSpread.errorOnRegul68LGap) {
                    localSpread.errorOnRegul68LGap.originalFixedAssetsFileIndex =
                        al.originalFixedAssetsFileIndex;
                    this.gap68LOnRegulN_1Errors.push(localSpread.errorOnRegul68LGap);
                    upsertVariablesDico = [];
                }

                // ** alsToDepreciateLoop
                // ** UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT
                // ** create depreciation ACR
                if (localSpread?.currentAlAcrData) {
                    let documentsLength: number = 0;
                    let importedPreviousDepreciationAmountSigned: number = 0;
                    const alNetAmountSigned: number = mathFix(
                        localSpread.currentAlAcrData.alNetAmountSigned,
                        2,
                    );
                    let gap = 0;
                    if (localSpread.currentAlAcrData?.type !== "N/A") {
                        documentsLength = localSpread.documents.length;
                        importedPreviousDepreciationAmountSigned = mathFix(
                            localSpread.currentAlAcrData.previousDepreciationAmountSigned,
                            2,
                        );
                    }

                    // **  normally, no documents.length = full depreciated fixedAsset, but importedVNC should be 0
                    if (importedPreviousDepreciationAmountSigned && !documentsLength) {
                        let lastImportLine =
                            localSpread.currentAlAcrData.depreciationTable[
                                localSpread.currentAlAcrData.depreciationTable.length - 1
                            ];
                        if (
                            lastImportLine.resumePeriodEnd >
                            moment(this.N_1AccountingPeriod.end).format("YYYY-MM-DD")
                        ) {
                            lastImportLine =
                                localSpread.currentAlAcrData.depreciationTable[
                                    localSpread.currentAlAcrData.depreciationTable.length - 2
                                ];
                        }

                        // ** generating gap depreciation is done with import fullDepreciatedFixedAssetsDialog
                        // if (localSpread.currentAlAcrData.depreciationTable?.length) {
                        //     if (lastImportLine.resumePeriodEnd < moment(this.accountingPeriod?.end).format("YYYY-MM-DD")) {
                        //         calculatedPreviousDepreciationAmountSigned = mathFix(lastImportLine.linearAccumulatedDepreciation, 2)
                        //     } else {
                        //         const currentPeriodLine = localSpread.currentAlAcrData.depreciationTable.find(line => line.resumePeriodEnd === moment(this.accountingPeriod?.end).format("YYYY-MM-DD"))
                        //         if (currentPeriodLine) {
                        //             calculatedPreviousDepreciationAmountSigned = mathFix(currentPeriodLine.linearAccumulatedDepreciation, 2)
                        //         }
                        //     }
                        // }

                        gap = -mathFix(
                            alNetAmountSigned - importedPreviousDepreciationAmountSigned,
                            // - calculatedPreviousDepreciationAmountSigned
                            2,
                        );
                        if (gap) {
                            const alObject = {
                                date: localSpread.currentAlAcrData.date,
                                // linearSpreadStartDate: localSpread.currentAlAcrData.linearSpreadStartDate,
                                aaName: localSpread.currentAlAcrData.accountableAccount.name,
                                aaDepreciationName:
                                    localSpread.currentAlAcrData.accountableAccountDepreciation
                                        .name,
                                wording: localSpread.currentAlAcrData.wording,
                                // type: localSpread.currentAlAcrData.type,
                                // rate: localSpread.currentAlAcrData.rateLinear,
                                alNetAmountSigned: mathFix(
                                    localSpread.currentAlAcrData.alNetAmountSigned,
                                    2,
                                ),
                                linearSpreadEndDate:
                                    localSpread.currentAlAcrData.linearSpreadEndDate,
                                importedPreviousDepreciationAmountSigned: mathFix(
                                    importedPreviousDepreciationAmountSigned,
                                    2,
                                ),
                                gap: gap,
                                endDepreciationDate: localSpread.currentAlAcrData
                                    .linearSpreadEndDate.length
                                    ? moment(lastImportLine.resumePeriodEnd).format("YYYY-MM-DD")
                                    : "",
                                currentAlAcrData: localSpread.currentAlAcrData,
                            };
                            if (this.adjustDocumentsOnFullDepreciatedFixedAssets?.length) {
                                const alreadyDone =
                                    this.adjustDocumentsOnFullDepreciatedFixedAssets.find(
                                        (ad) =>
                                            ad.accountingLines[1].amountSigned === gap &&
                                            ad.accountingLines[1].accountableAccount.name ===
                                                alObject.aaDepreciationName &&
                                            ad.accountingLines[0].wording.endsWith(
                                                alObject.wording,
                                            ),
                                    );
                                if (!alreadyDone) {
                                    this.errorsOnFullDepreciatedFixedAssets.push(alObject);
                                }
                            } else {
                                this.errorsOnFullDepreciatedFixedAssets.push(alObject);
                            }
                        }
                    } else if (!importedPreviousDepreciationAmountSigned && documentsLength) {
                        console.error(
                            "🚀 - alsToDepreciateLoop - documentsLength and no importedPreviousDepreciationAmountSigned :",
                            localSpread?.currentAlAcrData,
                        );
                        debugger;
                    }

                    // if (!this.errorsOnFullDepreciatedFixedAssets?.length && !this.gap68LOnRegulN_1Errors?.length) {
                    const upsertVariables = {
                        id: localSpread.currentAlAcrData.acrId || "",
                        auditCheckKey: this.auditCheckKeyToDepreciate,
                        key:
                            this.auditCheckKeyToDepreciate +
                            "_" +
                            this.companyId +
                            "_" +
                            localSpread.currentAlAcrData.documentId +
                            "_" +
                            localSpread.currentAlAcrData.alId,
                        companyId: this.companyId,
                        status: "UNKNOWN",
                        // accountingPeriodCreate: undefined,
                        // accountingPeriodUpdate: undefined,
                        thirdPartyCompanyCreate: localSpread.currentAlAcrData.thirdPartyCompany?.id
                            ? { connect: { id: localSpread.currentAlAcrData.thirdPartyCompany.id } }
                            : undefined,
                        thirdPartyCompanyUpdate: localSpread.currentAlAcrData.thirdPartyCompany?.id
                            ? { connect: { id: localSpread.currentAlAcrData.thirdPartyCompany.id } }
                            : undefined,
                        // documentCreateConnection: !BT ? {connect: {id: currentAlAcrData.documentId}} : undefined,
                        documentCreateConnection: undefined,
                        // documentUpdateConnection: !BT ? {connect: {id: currentAlAcrData.documentId}} : undefined,
                        documentUpdateConnection: undefined,
                        accountingLineCreateConnection: { connect: { id: al.al2.id } },
                        accountingLineUpdateConnection: { connect: { id: al.al2.id } },
                        // bankTransactionCreateConnection: BT ? {connect: {id: currentAlAcrData.documentId}} : undefined,
                        bankTransactionCreateConnection: undefined,
                        // bankTransactionUpdateConnection: BT ? {connect: {id: currentAlAcrData.documentId}} : undefined,
                        bankTransactionUpdateConnection: undefined,
                        deleteDocuments: localSpread.resultDocumentIdsToDelete || [],
                        documents: localSpread.documents,
                        data: JSON.parse(JSON.stringify(localSpread.currentAlAcrData)) || [],
                    };

                    if (
                        !this.errorsOnFullDepreciatedFixedAssets?.length &&
                        !this.gap68LOnRegulN_1Errors?.length
                    ) {
                        upsertVariablesDico.push(upsertVariables);
                    }
                }
            }

            if (
                this.errorsOnFullDepreciatedFixedAssets?.length ||
                this.gap68LOnRegulN_1Errors?.length
            ) {
                upsertVariablesDico = [];

                if (this.errorsOnFullDepreciatedFixedAssets?.length) {
                    this.fullDepreciatedFixedAssetsDialog = true;
                } else if (this.gap68LOnRegulN_1Errors?.length) {
                    this.gap68LOnRegulN_1ErrorsDialog = true;
                }
            } else if (
                upsertVariablesDico.length &&
                this.als2ToDepreciateLength &&
                upsertVariablesDico.length === this.als2ToDepreciateLength
            ) {
                let dateReprise = moment().format("YYYY-MM-DD");

                if(this.cutsACR.results?.length) {
                    dateReprise = moment(this.cutsACR.results[0].date).format("YYYY-MM-DD");
                }
                const prefixeDocument = `Reprise-${dateReprise}`;
                
                // ** loop creating depreciation ACRs (ACR.key: "rIr4hG5NdQWyEnIXvhnYtmmm")
                let promises = [];
                // reset old errors
                this.errorsUploadDocument.clear();
                for (const upsertVariables of upsertVariablesDico) {

                    promises.push(
                        (async () => {

                            const cutRes = await this.$apollo.mutate({
                                mutation: UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT,
                                variables: upsertVariables,
                            });

                            if(cutRes && cutRes.data && cutRes.data.upsertAuditCheckResult.id ) {
                                if(upsertVariables.data.urlLinkToDcoument){
                                    const documentName = prefixeDocument + "-" + moment().format('x');

                                    const fileToCreate: DataForDocument = {
                                        name: documentName,
                                        companyId: this.companyId,
                                        url: upsertVariables.data.urlLinkToDcoument,
                                        type: Document_type.MISCELLANEOUS,
                                        status: AuditCheckResult_status.VALIDATED,
                                        date: getDBFormattedDate(upsertVariables.data.date),
                                    };
                                    
                                    const fileUrl: FileUrlDoc = await UploadUrlDocumentService.createFileFromUrl(fileToCreate, this.$apollo);
                                    
                                    if(!fileUrl.error && fileUrl.documentId){
                                    
                                        const documentConnection = [ fileUrl.documentId];

                                        const auditCheckResultVariables: any = {
                                            acrId: cutRes.data.upsertAuditCheckResult.id,
                                            connectDocuments: documentConnection,
                                        };

                                        await this.$apollo.mutate({
                                            mutation: UPSERT_AUDIT_CHECK_RESULT_DOCUMENT,
                                            variables: auditCheckResultVariables,
                                        });
                                    }
                                    else if (fileUrl.error) {
                                        if(this.errorsUploadDocument.has(fileUrl.error)){
                                            this.errorsUploadDocument.get(fileUrl.error).push(upsertVariables.data.fixedAssetWording);
                                        } else {
                                            this.errorsUploadDocument.set(fileUrl.error, [upsertVariables.data.fixedAssetWording]);
                                        }
                                    }
                                }
                             }
                            
                        })(),
                    );
                    this.alIndex++;

                    if (promises.length === 10) {
                        try {
                            // eslint-disable-next-line no-await-in-loop
                            await Promise.all(promises);
                        } catch (e) {
                            console.error(
                                "Error while await Promise.all fixedAssetsCutPrevious ",
                                e,
                            );
                        }
                        promises = [];
                    }
                }

                if (promises.length) {
                    try {
                        await Promise.all(promises);
                    } catch (e) {
                        console.error("Error while await Promise.all fixedAssetsCutPrevious ", e);
                    }
                }

                // ** last upsert on cutPrevious ACR (ACR.key: "DNF1E0OlRCAENoSwsZSt6ZdG")
                if (this.alIndex === this.als2ToDepreciateLength) {
                    this.cutsACR.data.validated = true;
                    this.cutsACR.data.errorsUploadDocument = [];
                    if(this.errorsUploadDocument.size > 0){
                        this.cutsACR.data.errorsUploadDocument = Array.from(this.errorsUploadDocument.keys()).map((value) => {
                            return {error: value, fixedAssets: this.errorsUploadDocument.get(value)};
                        }); 
                    }

                    // ** alsToDepreciateLoop
                    //  ** UPSERT_AUDIT_CHECK_RESULT
                    // ** upsert cutsACR.data.validated
                    const upsertVariables: any = {
                        id: this.cutsACRId || "",
                        key: this.commentsACRKey,
                        companyId: this.companyId,
                        status: this.validated ? "VALIDATED" : "EDITION",
                        thirdPartyCompanyCreate: undefined,
                        thirdPartyCompanyUpdate: undefined,
                        accountingPeriodCreate: this.accountingPeriodId
                            ? { connect: { id: this.accountingPeriodId } }
                            : undefined,
                        accountingPeriodUpdate: this.accountingPeriodId
                            ? { connect: { id: this.accountingPeriodId } }
                            : undefined,
                        // documentCreateConnection: {connect: {id: this.invoice.id }},
                        // documentUpdateConnection: {connect: {id: this.invoice.id}},
                        // ******************************
                        // ** delete only "normal" cut result
                        // ** keep notInFECDocuments results
                        deleteDocuments: [],
                        // *******************************
                        // documents: this.cutDocument && !isEmpty(this.cutDocument) ? [this.cutDocument] : [],
                        documents: undefined,
                        auditCheckKey: this.acKey,
                        data: this.cutsACR.data || {},
                        type: "IN_AUDIT_REPORT",
                    };
                   
                    const storedCuts: any = await this.$apollo.mutate({
                        mutation: UPSERT_AUDIT_CHECK_RESULT,
                        variables: upsertVariables,
                    });

                    if (storedCuts) {
                        this.alsToDepreciateLoopLoading = false;
                        this.recoveryFinished = true;
                    }
                    this.validated = true;
                }
            }
            this.alsToDepreciateLoopLoading = false;
        }
    }

    async refresh() {
        if (this.$apollo.queries?.auditItems) {
            await this.$apollo.queries.auditItems.refetch();
        } else {
            // eslint-disable-next-line
            debugger; // git-ignore
        }
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    get commentsACRKey() {
        return this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId;
    }

    // get deleteDocuments() { return this.cutAcrResultDocumentIdsToDelete || []
    // }

    async storeComments(action = undefined) {
        let data: any = {};
        if (this.cutsACR?.data) {
            data = JSON.parse(JSON.stringify(this.cutsACR.data));
        }

        data.shortComment = this.shortComment || "";
        data.longComment = this.longComment || "";
        data.validated = this.validated || false;
        data.currentPeriodIsFirstPeriod = this.currentPeriodIsFirstPeriod || false;
        data.noData = this.noData || false;

        // ** storeCuts
        // ** UPSERT_AUDIT_CHECK_RESULT
        // ** in importFunction: create cutsACR with data.fixedAssetsFile
        // ** in cutPrevious > storeCuts: update cutsACR + add documents: [this.cutDocument]
        const upsertVariables: any = {
            id: this.cutsACRId || "",
            key: this.commentsACRKey,
            companyId: this.companyId,
            status: data.validated ? "VALIDATED" : "EDITION",
            thirdPartyCompanyCreate: undefined,
            thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // documentCreateConnection: {connect: {id: this.invoice.id }},
            // documentUpdateConnection: {connect: {id: this.invoice.id}},
            deleteDocuments: this.cutAcrResultDocumentIdsToDelete || [],
            documents:
                this.cutDocument && !isEmpty(this.cutDocument) ? [this.cutDocument] : undefined,
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            auditCheckKey: this.acKey,
            data: data || {},
            type: "IN_AUDIT_REPORT",
            reviewed: this.reviewed,
        };

        // eslint-disable-next-line no-await-in-loop
        const storedCuts: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        if (storedCuts?.data?.upsertAuditCheckResult?.id) {
            // await this.createUserActivity(action) // deprecated

            if (!this.noData && !this.currentPeriodIsFirstPeriod) {
                // ** backend getGeneralLedger in getItems do await gl.computeCarryForward()
                this.refresh();
            }
        }
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.storeComments("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.storeComments("UPDATE");
        }
    }

    async storeCuts() {
        this.storeCutsLoading = true;
        let data: any = {};
        if (this.cutsACR?.data) {
            data = JSON.parse(JSON.stringify(this.cutsACR.data)) || {};
        }

        // ** create common ACR, containing:
        // ** shortComment + longComment
        // ** new cut document
        // // reconciliation is automatically done in backend "if (als2ToReconciliate.length..."

        data.shortComment = this.shortComment || "";
        data.longComment = this.longComment || "";
        data.fixedAssetsFile = this.fixedAssetsFile || undefined;
        data.errorMessages = this.errorMessages || undefined;
        data.validated = false;
        data.notInFECDocuments = this.notInFECDocuments || undefined;

        const documentsToCreate = [];
        if (this.notInFECDocuments?.length) {
            const ids = this.notInFECDocuments.map((doc) => doc.id);
            if (!ids?.length) {
                documentsToCreate.push(...this.notInFECDocuments);
            }
        }
        if (this.cutDocument && !isEmpty(this.cutDocument)) {
            documentsToCreate.push(this.cutDocument);
        }

        // ** storeCuts
        // ** UPSERT_AUDIT_CHECK_RESULT
        // ** in importFunction: create cutsACR with data.fixedAssetsFile
        // ** in cutPrevious > storeCuts: update cutsACR + add documents: [this.cutDocument]
        const upsertVariables: any = {
            id: this.cutsACRId || "",
            key: this.commentsACRKey,
            companyId: this.companyId,
            status: this.validated ? "VALIDATED" : "EDITION",
            thirdPartyCompanyCreate: undefined,
            thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // documentCreateConnection: {connect: {id: this.invoice.id }},
            // documentUpdateConnection: {connect: {id: this.invoice.id}},
            deleteDocuments: this.cutAcrResultDocumentIdsToDelete || [],
            documents: documentsToCreate.length ? documentsToCreate : undefined,
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            auditCheckKey: this.acKey,
            data: data || {},
            type: "IN_AUDIT_REPORT",
            reviewed: this.reviewed,
        };
        // eslint-disable-next-line no-await-in-loop
        const storedCuts: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });
        if (storedCuts) {
            // ** backend getGeneralLedger in getItems do await gl.computeCarryForward()
            this.refresh();
        }
    }

    deleteAcrDone() {
        this.deleteAuditCheckResultLoading = false;
        this.deleteAuditCheckResultDialog = false;
        this.refresh();
    }

    changeDotAmoType() {
        this.currentAlAcrData.linearDepreciation =
            this.depreciationType && this.depreciationType === "Linéaire" ? true : false;
        this.currentAlAcrData.dotAmoType = this.currentAlAcrData.linearDepreciation
            ? "Dot. Amos - L - "
            : "Dot. Amos - D - ";
    }

    // minMaxRules(globalVatAmountSigned) {
    //     return [
    //         v => (parseInt(v) <= globalVatAmountSigned) || 'Valeur maximale ' + [globalVatAmountSigned] + '€',
    //         v => (parseInt(v) >= 0) || 'Valeur minimale >= 0'
    //     ]
    // }

    get accountableAccountNameAndDescription() {
        if (
            this.currentAlAcrData &&
            this.currentAlAcrData.accountableAccount &&
            this.currentAlAcrData.accountableAccount.name
        ) {
            if (this.currentAlAcrData.accountableAccount.description) {
                return (
                    this.currentAlAcrData.accountableAccount.name +
                    " - " +
                    this.currentAlAcrData.accountableAccount.description
                );
            } else {
                return this.currentAlAcrData.accountableAccount.name;
            }
        }
        return "";
    }

    onQueryDone2(data) {
        // this.fromCarryForwardDetail = data.filter(d => d.fromCarryForward === true)
        // return this.fromCarryForwardDetail
    }

    onQueryDone28(data) {}

    onQueryDone145(data) {}

    onQueryDone25(data) {}

    onQueryDone26(data) {}

    onQueryDone27(data) {}

    async onFixedAssetsImported(data) {
        this.cutDocument = undefined;
        this.storeFixedAssetsLoading = true;
        if (data.fixedAssetsFile.length) {
            const fixedAssetsFile = data.fixedAssetsFile
                ? JSON.parse(JSON.stringify(data.fixedAssetsFile))
                : [];

            // ** tests
            const errorMessages = [];

            if (this.alsToReconciliateSum) {
                errorMessages.push(
                    "Mon dossier - exercices - N-1 : 'Calculer les reports à nouveau'",
                );
            } else {
                // if (!isEmpty(this.gaps)) {
                //     for (const rootGroup of Object.keys(this.gaps)) {
                //         for (const accAccountObj of this.gaps[rootGroup]) {
                //             errorMessages.push("Le compte " + accAccountObj.aaName + " a un écart de " + accAccountObj.gap + "€")
                //         }
                //     }
                // }
                // if (this.wrongAaPairs?.length) {
                //     errorMessages.push("Les comptes suivants ne sont pas correctement appareillés : ")
                //     for (const wrongAaPair of this.wrongAaPairs) {
                //         errorMessages.push(" - " + wrongAaPair)
                //     }
                // }

                for (const line of fixedAssetsFile) {
                    // ** aaNameFixedAsset - compte d'immobilisation
                    if (line.aaNameFixedAsset) {
                        if (typeof line.aaNameFixedAsset === "number") {
                            line.aaNameFixedAsset = `${line.aaNameFixedAsset}`;
                        }

                        line.aaNameFixedAsset = line.aaNameFixedAsset.length
                            ? line.aaNameFixedAsset.replace(/\s/g, "")
                            : 0; // spaces

                        if (typeof line.aaNameFixedAsset !== "string") {
                            errorMessages.push(
                                "Le compte d'immobilisation de " +
                                    line.wording +
                                    " doit être de type text",
                            );
                        }

                        if (!line.aaNameFixedAsset.startsWith("2")) {
                            errorMessages.push(
                                "Le compte d'immobilisation de " +
                                    line.wording +
                                    " doit commencer par '2'",
                            );
                        }

                        if (line.aaNameFixedAsset.startsWith("28")) {
                            errorMessages.push(
                                "Le compte d'immobilisation de " +
                                    line.wording +
                                    "  ne doit pas commencer par '28'",
                            );
                        }
                    }

                    // ** aaNameDepreciation - compte d'amortissement
                    if (line.aaNameDepreciation?.length) {
                        if (typeof line.aaNameDepreciation === "number") {
                            line.aaNameDepreciation = `${line.aaNameDepreciation}`;
                        }

                        if (typeof line.aaNameDepreciation !== "string") {
                            errorMessages.push("Le compte d'amortissement doit être de type text");
                        }

                        if (
                            !line.aaNameDepreciation?.startsWith("28") &&
                            !line.aaNameDepreciation?.startsWith("N/A")
                        ) {
                            errorMessages.push(
                                "Le compte d'amortissement doit commencer par '28' ou être 'N/A'",
                            );
                        }
                    } else {
                        console.error("line.aaNameDepreciation to give", line.aaNameDepreciation);
                        debugger;
                        if (line.type !== "N/A") {
                            line.aaNameDepreciation = "28" + line.aaNameFixedAsset.slice(1, 5);
                        } else {
                            line.aaNameDepreciation = null;
                        }
                    }

                    // ** date
                    if (line.date) {
                        if (!moment(line.date, "DD/MM/YYYY").isValid()) {
                            errorMessages.push(
                                "La date de " + line.wording + " doit être au format 25/04/2022",
                            );
                        }
                    }

                    // ** linearSpreadStartDate
                    if (line.linearSpreadStartDate) {
                        if (!moment(line.linearSpreadStartDate, "DD/MM/YYYY").isValid()) {
                            errorMessages.push(
                                "La date de mise de " +
                                    line.wording +
                                    " en service doit être au format 25/04/2022",
                            );
                        }
                    }

                    // ** alNetAmountSigned - prix d'acquisition
                    if (line.alNetAmountSigned) {
                        if (typeof line.alNetAmountSigned === "string") {
                            line.alNetAmountSigned = parseFloat(line.alNetAmountSigned);
                        }
                        if (typeof line.alNetAmountSigned !== "number") {
                            errorMessages.push(
                                "Le prix d'acquisition " +
                                    line.alNetAmountSigned +
                                    " de " +
                                    line.wording +
                                    "  doit être au format texte ou nombre",
                            );
                        }
                    }

                    // ** alVatAmountSigned - TVA déduite
                    if (line.alVatAmountSigned) {
                        if (typeof line.alVatAmountSigned === "string") {
                            const containingOtherCharacters = checkAmount(line.alVatAmountSigned);
                            if (containingOtherCharacters) {
                                errorMessages.push("La TVA déduite doit contenir un nombre");
                            } else {
                                line.alVatAmountSigned = this.stringToNumber(
                                    line.alVatAmountSigned,
                                );
                            }
                        }
                        if (typeof line.alVatAmountSigned !== "number") {
                            errorMessages.push(
                                "La TVA déduite doit être au format texte ou nombre",
                            );
                        }
                    }

                    // ** depreciableAmountSigned - Base amortissable
                    if (line.depreciableAmountSigned) {
                        if (typeof line.depreciableAmountSigned === "string") {
                            const containingOtherCharacters = checkAmount(
                                line.depreciableAmountSigned,
                            );
                            if (containingOtherCharacters) {
                                errorMessages.push("La base amortissable doit contenir un nombre");
                            } else {
                                line.depreciableAmountSigned = this.stringToNumber(
                                    line.depreciableAmountSigned,
                                );
                            }
                        }
                        if (typeof line.depreciableAmountSigned !== "number") {
                            errorMessages.push(
                                "La base amortissable doit être au format texte ou nombre",
                            );
                        }
                    }

                    if (line.type) {
                        if (typeof line.type !== "string") {
                            errorMessages.push(
                                "Le mode d'amortissements doit être au format texte et parmi 'L' ou 'D' ou 'N/A'",
                            );
                        } else {
                            const types = ["L", "D", "N/A"];
                            if (!types.find((t) => t === line.type)) {
                                errorMessages.push(
                                    "Le mode d'amortissements doit être parmi 'L' ou 'D' ou 'N/A'",
                                );
                            }
                        }
                    }

                    if (line.rate !== "N/A") {
                        if (line.rate.endsWith("%")) {
                            line.rate = line.rate.slice(0, -1);
                        }

                        if (typeof line.rate === "string") {
                            line.rate = this.stringToNumber(line.rate);
                        }

                        if (typeof line.rate !== "number") {
                            errorMessages.push(
                                "Le taux d'amortissements doit être au format texte ou nombre",
                            );
                        } else if (line.rate < 1 && line.rate > 0) {
                            errorMessages.push(
                                "Un amortissement supérieur à 100 ans est improbable. Exemples de format: durée 5 ans = 20; durée 2 ans = 50",
                            );
                        } else if (
                            line.rate < 0
                            // || line.rate > 100
                        ) {
                            errorMessages.push("Le taux d'amortissements doit être supérieur à 0");
                            // errorMessages.push("Le taux d'amortissements doit être compris entre 0 et 100")
                        } else if (line.rate == 33) {
                            // ** 3 years
                            line.rate = 33.33;
                        } else if (line.rate == 16) {
                            // ** 6 years
                            line.rate = 16.67;
                        } else if (line.rate == 14) {
                            // ** 7 years
                            line.rate = 14.29;
                        } else if (line.rate == 11) {
                            // ** 9 years
                            line.rate = 11.11;
                        }
                    }

                    if (line.selectedYearDuration) {
                        if (typeof line.selectedYearDuration === "string") {
                            line.selectedYearDuration = parseInt(line.selectedYearDuration);
                        }
                        if (typeof line.selectedYearDuration !== "number") {
                            errorMessages.push(
                                "La durée d'amortissements doit être au format texte ou nombre",
                            );
                        } else {
                            if (line.selectedYearDuration < 0 || line.selectedYearDuration > 100) {
                                errorMessages.push(
                                    "La durée d'amortissements doit être exprimée en années et comprise entre 0 et 100",
                                );
                            }
                        }
                    }

                    if (line.selectedMonthDuration) {
                        if (typeof line.selectedMonthDuration === "string") {
                            line.selectedMonthDuration = parseInt(line.selectedMonthDuration);
                        }
                        if (typeof line.selectedMonthDuration !== "number") {
                            errorMessages.push(
                                "La durée d'amortissements en mois doit être au format texte ou nombre",
                            );
                        } else {
                            if (
                                line.selectedMonthDuration < 0 ||
                                line.selectedMonthDuration > 1200
                            ) {
                                errorMessages.push(
                                    "La durée d'amortissements doit être exprimée en années et comprise entre 0 et 1200 (100 ans))",
                                );
                            }
                        }
                    }

                    // ** previousDepreciationAmountSigned - cumul d'amortissements à fin N-1
                    if (line.previousDepreciationAmountSigned) {
                        if (typeof line.previousDepreciationAmountSigned === "string") {
                            line.previousDepreciationAmountSigned = parseFloat(
                                line.previousDepreciationAmountSigned,
                            );
                        }

                        if (typeof line.previousDepreciationAmountSigned !== "number") {
                            errorMessages.push(
                                "Le cumul d'amortissements à fin N-1 de " +
                                    line.wording +
                                    " : " +
                                    line.previousDepreciationAmountSigned +
                                    " doit être au format texte ou nombre",
                            );
                        }
                    }

                    if (line.type === "D") {
                        if (!line.previousDerogationDepreciationAmountSigned) {
                            errorMessages.push(
                                "En cas d'amortissements dégressif, le cumul d'amortissements dérogatoire à fin N-1 de " +
                                    line.wording +
                                    " doit être renseigné",
                            );
                        }

                        if (!line.aaNameDerogation) {
                            errorMessages.push(
                                "En cas d'amortissements dégressif, le compte d'amortissement dérogatoire de " +
                                    line.wording +
                                    "doit être renseigné",
                            );
                        }
                    }

                    // ** previousDerogationDepreciationAmountSigned - cumul d'amortissements dérogatoire à fin N-1
                    if (line.previousDerogationDepreciationAmountSigned) {
                        if (typeof line.previousDerogationDepreciationAmountSigned === "string") {
                            const isStringAmount = checkAmount(
                                line.previousDerogationDepreciationAmountSigned,
                            );
                            if (isStringAmount) {
                                line.previousDerogationDepreciationAmountSigned =
                                    +line.previousDerogationDepreciationAmountSigned;
                            } else {
                                errorMessages.push(
                                    "Le cumul d'amortissements dérogatoire à fin N-1 doit contenir un nombre",
                                );
                            }
                        }

                        if (line.previousDerogationDepreciationAmountSigned < 0) {
                            errorMessages.push(
                                "Le cumul d'amortissements dérogatoire à fin N-1 de " +
                                    line.wording +
                                    " : " +
                                    line.previousDerogationDepreciationAmountSigned +
                                    " doit être positif ou nul",
                            );
                        }

                        if (typeof line.previousDerogationDepreciationAmountSigned !== "number") {
                            errorMessages.push(
                                "Le cumul d'amortissements dérogatoire à fin N-1 doit être au format texte ou nombre",
                            );
                        }
                        if (!line.aaNameDerogation) {
                            errorMessages.push(
                                "En cas d'amortissements dégressif, le compte d'amortissements dérogatoire utilisé doit être renseigné",
                            );
                        }
                    }

                    if (line.aaNameDerogation) {
                        if (typeof line.aaNameDerogation === "number") {
                            line.aaNameDerogation = `${line.aaNameDerogation}`;
                        }

                        line.aaNameDerogation = line.aaNameDerogation.length
                            ? line.aaNameDerogation.replace(/\s/g, "")
                            : 0; // spaces

                        if (typeof line.aaNameDerogation !== "string") {
                            errorMessages.push(
                                "Le compte d'amortissement dérogatoire de " +
                                    line.wording +
                                    " doit être de type text",
                            );
                        }

                        if (
                            !line.aaNameDerogation.startsWith("145") &&
                            !line.aaNameDerogation.startsWith("28")
                        ) {
                            errorMessages.push(
                                "Le compte d'amortissement dérogatoire de " +
                                    line.wording +
                                    " doit commencer par '145' ou '28'",
                            );
                        }
                    }

                    if (line.previousVNC) {
                        if (typeof line.previousVNC === "string") {
                            const containingOtherCharacters = checkAmount(line.previousVNC);
                            if (containingOtherCharacters) {
                                errorMessages.push(
                                    "La valeur nette comptable à fin N-1 doit contenir un nombre",
                                );
                            } else {
                                line.previousVNC = this.stringToNumber(line.previousVNC);
                            }
                        }
                        if (typeof line.previousVNC !== "number") {
                            errorMessages.push(
                                "La valeur nette comptable à fin N-1 doit être au format texte ou nombre",
                            );
                        }
                    }

                    if(line.urlLinkToDcoument){
                        if (typeof line.urlLinkToDcoument === "string") {
                            if(!UploadUrlDocumentService.isValidUrl(line.urlLinkToDcoument)){
                                errorMessages.push(
                                    `Le lien du document "${line.wording}" doit être un lien valide`,
                                );
                            }
                            else {
                                const isAccessible = await UploadUrlDocumentService.canAccessUrl(line.urlLinkToDcoument);
                                if (!isAccessible) {
                                    errorMessages.push(
                                        `Le lien du document "${line.wording}" doit être accessible et public`,
                                    );
                                }
                            }       
                        }
                       else{
                            errorMessages.push(
                                `Le lien du document "${line.wording}" doit être au format texte`,
                            );
                        }
                    }
                }

                this.errorMessages = errorMessages.length ? [...new Set(errorMessages)] : [];

                if (this.errorMessages.length) {
                    this.errorMessages.sort();
                    this.errorMessages.unshift("ECHEC DE L'IMPORT :");
                }
            }

            if (!isEmpty(this.auditItems)) {
                // for (const fa of fixedAssetsFile) {
                //     const stringToFloatProperties = ["alNetAmountSigned", "previousDepreciationAmountSigned", "previousVNC"]
                //     for (const key of stringToFloatProperties) {
                //         fa[key] = fa[key].length ? parseFloat(fa[key].replace(",", ".")) : 0
                //     }
                // }

                // ** amounts are all positifs
                // ** this.total2imported should be positif or 0
                // const total2imported = sumBy(fixedAssetsFile, 'alNetAmountSigned')

                // ** this.total28imported & this.total145imported should be negatif or 0
                // const total28imported = -mathFix(sumBy(fixedAssetsFile, 'previousDepreciationAmountSigned'), 2)

                // const total145imported = -(sumBy(this.fixedAssetsFile, 'previousDepreciationAmountSigned'))

                // this.gap2 = this.gl2_total - this.als2NotFromCarryForwardSum - total2imported
                // this.gap28 = this.gl28_total - this.als28NotFromCarryForwardSum - total28imported
                // this.gap145 = this.gl145_total - this.als145NotFromCarryForwardSum - total145imported

                if (!this.auditItems?.cutsACR || isEmpty(this.auditItems.cutsACR)) {
                    this.auditItems.cutsACR = { data: {} };
                }

                this.auditItems.cutsACR.data.fixedAssetsFile = fixedAssetsFile;
                this.auditItems.cutsACR.data.errorMessages = this.errorMessages.length
                    ? errorMessages
                    : null;

                this.fixedAssetsFile = fixedAssetsFile;

                // ** onFixedAssetsImported
                // this.storeFixedAssetsLoading = false
                this.storeCuts();
            }
        }
    }

    get disabledNextBtn() {
        if (
            this.currentAlAcrData &&
            this.currentAlAcrData.selectedYearDuration &&
            this.currentAlAcrData.selectedYearDuration > 0 &&
            this.currentAlAcrData.linearSpreadStartDate &&
            this.formatDatePicker(this.currentAlAcrData.linearSpreadStartDate).length &&
            this.formatDatePicker(this.currentAlAcrData.linearSpreadStartDate).length === 10 &&
            this.inAccountingPeriod &&
            this.inAccountingPeriod.end
        ) {
            return false;
        }
        return true;
    }

    // get dataTableHeight() {
    //     return "min(" + (48 * (this.currentAlAcrData.depreciationTable.length + 2)) + "px, 30vh)"
    // }

    closeUploadDocumentDialog() {
        this.dialogUploadDocument = false;
        this.$emit("onEdit");
    }

    startToBeDoneIfNecessary() {
        // if (this.mode !== "ToBeDone") {
        //     const reconciliation = this.getPendingReconciliation()
        //     if (reconciliation) {
        //         this.$router.push({
        //             name: "toBeDone",
        //             params: {
        //                 companyId: this.selectedCompany.id,
        //                 reconciliationId: reconciliation.id,
        //                 backAtTheEnd: "1"
        //             }
        //         });
        //     } else {
        //         this.$router.push({
        //             name: "toBeDone",
        //             params: {
        //                 companyId: this.selectedCompany.id,
        //                 documentId: this.documentId,
        //                 backAtTheEnd: "1"
        //             }
        //         });
        //     }
        // } else {
        //     this.$emit('task-ended', {
        //         documentId: this.documentId
        //     });
        // }
        this.$emit("task-ended", {
            documentId: this.documentId,
        });
    }

    async onFileChanged(e) {
        // Réinitialisation des variables
        // this.headers = []
        // this.items = []
        // this.event = e;
        // // Vérification de l'existance du fichier
        // if (e && ((e.target && e.target.files) || e.file)) {
        //     let file
        //     if (e.target && e.target.files) {
        //         file = e.target.files[0]
        //     } else {
        //         file = e.file
        //     }
        //     const self = this;
        //     const reader = new FileReader();
        //     // Traitement du fichier
        //     reader.onload = async function () {
        //         const { result } = reader;
        //         if (result) {
        //             self.fileName = file.name.toString();
        //             self.headers = [ // Header du tableau
        //                 {
        //                     text: 'Compagnie',
        //                     align: 'center',
        //                     sortable: false,
        //                     value: 'company'
        //                 },
        //                 { text: 'Siret', value: 'siret', align: 'center' },
        //                 { text: 'Prix (TTC)', value: 'netAmount', align: 'center' },
        //                 // { text: 'Prix (HT)', value: 'grossAmount', align: 'center' },
        //                 // { text: 'Montant TVA', value: 'vatAmount', align: 'center' },
        //                 { text: 'TVA', value: 'vatRate', align: 'center' },
        //                 { text: 'Date de vente', value: 'date', align: 'center' },
        //                 { text: "Date d'échéance", value: 'dueDate', align: 'center' },
        //                 { text: 'Numero de facture', value: 'invoiceNumber', align: 'center' },
        //                 { text: "Sous-total", value: "netAmount1", align: "center" },
        //                 { text: 'Information', value: 'information', align: 'center' }
        //             ]
        //             let buffer: Array<string> = (result + "").split(/(?:\r\n?|\n)/)
        //             // buffer.splice(0, 1)
        //             const datas = buffer.join("\n")
        //             self.items = await self.getJson(datas.replace(/;/g, ","))
        //             self.items.map((x) => {
        //                 const invoicesPrices = self.resultInvoice(
        //                     x.grossAmount ? parseFloat(x.grossAmount) : 0,
        //                     x.netAmount ? parseFloat(x.netAmount) : 0,
        //                     x.vatRate ? parseFloat(x.vatRate) : 0,
        //                     x.vatAmount ? parseFloat(x.vatAmount) : 0
        //                 )
        //                 x.grossAmount = invoicesPrices.grossAmount
        //                 x.netAmount = invoicesPrices.netAmount
        //                 x.vatRate = invoicesPrices.vatRate
        //                 x.vatAmount = invoicesPrices.vatAmount
        //                 return x
        //             })
        //         }
        //     }
        //     reader.readAsText(file);
        // }
    }

    async cutPrevious() {
        let document: any = {};
        this.cutDocument = {};

        if (this.alsToCut?.length) {
            const accountingLines = [];

            const accountingPeriodStartDate = moment(this.accountingPeriod.start).format(
                "YYYY-MM-DD",
            );
            const recoveryWording = "Reprise immos + amos " + this.formatDate(this.selectedDate);
            if (this.fixedAssetsFile?.length) {
                // ** contrepassation du grand livre N-1
                for (const p of this.alsToCut) {
                    if (p.debit || p.credit) {
                        // eslint-disable-next-line no-await-in-loop
                        const aa = await getAuditConnectAccountableAccount(
                            this.$store,
                            this.$apollo,
                            p.accountableAccountName,
                        );
                        const al = {
                            date: accountingPeriodStartDate,
                            wording: recoveryWording,
                            amountSigned: -(p.debit + p.credit) || 0,
                            amount: Math.abs(p.debit + p.credit) || 0,
                            accountableAccount: aa,
                            company: { connect: { id: this.companyId } },
                            type: "ACCOUNTING",
                        };
                        accountingLines.push(al);
                    }
                }

                // ** new detailled fixedAssets and depreciations
                const notInFECDocumentsCopy = JSON.parse(JSON.stringify(this.notInFECDocuments));
                const nifd = this.fixedAssetsFile.map((f) => ({
                    aaNameFixedAsset: f.aaNameFixedAsset,
                    notInFECDocuments: f.notInFECDocuments,
                    // wording: f.wording,
                    // alNetAmountSigned: f.alNetAmountSigned,
                }));

                for (const mf of this.fixedAssetsFile) {
                    // ** check this.fixedAssetsFile.length
                    mf.notInFECDocuments = false;
                    if (notInFECDocumentsCopy?.length) {
                        const notInFECDocIndex = notInFECDocumentsCopy.findIndex((doc) =>
                            doc.accountingLines.some(
                                (al) =>
                                    al.wording.endsWith(mf.wording) &&
                                    al.accountableAccount.name === mf.aaNameFixedAsset,
                            ),
                        );
                        mf.notInFECDocuments = notInFECDocIndex !== -1 || false;
                        if (mf.notInFECDocuments) {
                            notInFECDocumentsCopy.splice(notInFECDocIndex, 1);
                        }
                    }
                    if (!mf.notInFECDocuments) {
                        const aaFA = mf["newAaNameFixedAsset"]
                            ? mf["newAaNameFixedAsset"]
                            : mf["aaNameFixedAsset"];
                        if (mf["alNetAmountSigned"]) {
                            const al2 = {
                                date: accountingPeriodStartDate,
                                wording: recoveryWording + " - " + mf["wording"].trim(),
                                amountSigned: mf["alNetAmountSigned"],
                                amount: mf["alNetAmountSigned"],
                                // eslint-disable-next-line no-await-in-loop
                                /* eslint-disable no-await-in-loop */
                                accountableAccount: await getAuditConnectAccountableAccount(
                                    this.$store,
                                    this.$apollo,
                                    aaFA,
                                ),
                                company: { connect: { id: this.companyId } },
                                type: "ACCOUNTING",
                            };
                            accountingLines.push(al2);
                        }

                        if (mf["previousDepreciationAmountSigned"]) {
                            const aaL = mf["newAaNameDepreciation"]
                                ? mf["newAaNameDepreciation"]
                                : mf["aaNameDepreciation"]; // ** is always 28
                            const alLinear = {
                                date: accountingPeriodStartDate,
                                wording: recoveryWording + " - " + mf["wording"].trim(),
                                amountSigned: -mf["previousDepreciationAmountSigned"],
                                amount: mf["previousDepreciationAmountSigned"],
                                /* eslint-disable no-await-in-loop */
                                accountableAccount: await getAuditConnectAccountableAccount(
                                    this.$store,
                                    this.$apollo,
                                    aaL,
                                ),
                                company: { connect: { id: this.companyId } },
                                type: "ACCOUNTING",
                            };
                            accountingLines.push(alLinear);
                        }

                        if (mf["previousDerogationDepreciationAmountSigned"]) {
                            const aaDerog = mf["aaNameDerogation"]; // ** may be 145 or 28
                            const alDerog = {
                                date: accountingPeriodStartDate,
                                wording: recoveryWording + " - " + mf["wording"].trim(),
                                amountSigned: -mf["previousDerogationDepreciationAmountSigned"],
                                amount: mf["previousDerogationDepreciationAmountSigned"],
                                /* eslint-disable no-await-in-loop */
                                accountableAccount: await getAuditConnectAccountableAccount(
                                    this.$store,
                                    this.$apollo,
                                    aaDerog,
                                ),
                                company: { connect: { id: this.companyId } },
                                type: "ACCOUNTING",
                            };
                            accountingLines.push(alDerog);
                        }
                    }
                }

                const testSum = mathFix(sumBy(accountingLines, "amountSigned"), 2);
                if (testSum !== 0) {
                    console.error("testSum !== 0", testSum);
                    debugger;

                    // ** immos GL
                    const filtered2GL = accountingLines.filter(
                        (al) =>
                            al.wording === "Reprise immos + amos 01/01/2023" &&
                            !al.accountableAccount.connect.uniqueName.name.startsWith("28"),
                    );

                    const filtered2GLSum = mathFix(sumBy(filtered2GL, "amountSigned"), 2);

                    // ** amos GL
                    const filtered28GL = accountingLines.filter(
                        (al) =>
                            al.wording === "Reprise immos + amos 01/01/2023" &&
                            al.accountableAccount.connect.uniqueName.name.startsWith("28"),
                    );

                    const filtered28GLSum = mathFix(sumBy(filtered28GL, "amountSigned"), 2);

                    // ** immos table sum
                    const filtered2TableSum = mathFix(
                        sumBy(this.fixedAssetsFile, "alNetAmountSigned"),
                        2,
                    );

                    // ** amos table sum
                    const filtered28TableSum = mathFix(
                        sumBy(this.fixedAssetsFile, "previousDepreciationAmountSigned"),
                        2,
                    );

                    if (-filtered2GLSum !== filtered2TableSum) {
                        console.error(
                            "filtered2GLSum - filtered2TableSum = error :",
                            filtered2GLSum,
                            filtered2TableSum,
                            filtered2GLSum - filtered2TableSum,
                        );
                        debugger;
                    }

                    if (filtered28GLSum !== filtered28TableSum) {
                        console.error(
                            "filtered28GLSum - filtered28TableSum = error : ",
                            filtered28GLSum,
                            filtered28TableSum,
                            filtered28GLSum - filtered28TableSum,
                        );
                        debugger;
                    }
                }

                document = getEmptyDocument(
                    this.companyId,
                    recoveryWording,
                    "MISCELLANEOUS_OPERATION",
                    accountingPeriodStartDate,
                    this.currentUser.id,
                    undefined,
                    accountingLines,
                    true,
                );
            }
        }

        this.cutDocument = document || {};

        this.cutDialog = true;
    }

    openObject(documentId, objectType) {
        if (objectType === "document") {
            this.$router.push({
                name: "document",
                params: {
                    companyId: this.companyId,
                    id: documentId,
                },
            });
        } else if (objectType === "bankTransaction") {
            this.$router.push({
                name: "reconciliation",
                params: {
                    companyId: this.companyId,
                    bankTransactionId: documentId,
                },
            });
        } else {
            debugger; // git-ignore
        }
    }

    get showDeleteAcrBtnIfRecovery() {
        this.showDeleteAcrBtnTooltipMessage = "";
        if (this.cutsACR?.id) {
            if (this.closedPeriod) {
                this.showDeleteAcrBtnTooltipMessage = "Exercice N clôturé";
                return false;
            }

            if (
                this.cutsACR?.accountingPeriod?.id &&
                this.accountingPeriod?.id &&
                this.cutsACR.accountingPeriod.id != this.accountingPeriod.id
            ) {
                this.showDeleteAcrBtnTooltipMessage = "Reprise effectuée sur une autre période";
                return false;
            }

            if (this.validated) {
                return true;
            }

            this.showDeleteAcrBtnTooltipMessage =
                "Après la suppression : Mon dossier - Exercices - N-1 - Calculer les reports à nouveau";
            return true;
        } else if (this.depreciationAcrIds?.length) {
            console.error(
                "no cutsACR.id && this.depreciationAcrIds?.length",
                this.depreciationAcrIds?.length,
            );
            debugger;
            this.showDeleteAcrBtnTooltipMessage =
                "Après la suppression : Mon dossier - Exercices - N-1 - Calculer les reports à nouveau";
            return true;
        }
        this.showDeleteAcrBtnTooltipMessage = "Aucune donnée";
        return false;
    }

    get importConditions() {
        if (this.deleteAuditCheckResultLoading) {
            return false;
        }
        if (this.validated) {
            return false;
        }
        // if (this.wrongAaPairs?.length) {
        //     return true
        // }
        // if (this.notInBobbeeAccountableAccounts?.length) {
        //     return true
        // }
        if (!this.fixedAssetsFile?.length) {
            return true;
        }
        if (this.someDecliningDepreciationError) {
            return true;
        }
        if (this.gaps?.["2"] || this.gaps?.["28"] || this.gaps?.["145"]) {
            return true;
        }
        if (this.changeAccountableAccountsGapsDialog) {
            return true;
        }
        if (this.gap_fixedAssetsAccountableAccount?.gapData?.glWithoutImportResume?.length) {
            return true;
        }
        if (this.errorMessages?.length) {
            return true;
        }
        return false;
    }

    get cutConditions() {
        if (
            (this.als2ToCut?.length || this.als26ToCut?.length || this.als27ToCut?.length) &&
            !this.cutAcrResultDocumentIdsToDelete?.length &&
            !this.als2ToDepreciate?.length
        ) {
            return true;
        }
        if (this.errorMessages?.length) {
            return true;
        }
        return false;
    }

    get depreciateConditions() {
        if (this.validated) return false;

        if (this.gap68LOnRegulN_1Errors?.length && !this.showUpdatedLinearSpreadStartDateBtn)
            return false;

        if (
            this.als2ToDepreciate?.length &&
            this.als2ToDepreciateLength // ** for progress-linear counter
        ) {
            return true;
        }
        return false;
    }

    get commentDisabled() {
        if (this.closedPeriod) {
            return true;
        }
        if (this.validated) {
            return true;
        }
        return false;
    }

    get validationDisabled() {
        if (this.closedPeriod) {
            return true;
        }
        if (this.loading) {
            return true;
        }
        if (this.dataLoading) {
            return true;
        }
        if (!this.accountingPeriod) {
            return true;
        }
        return false;
    }

    stringToNumber(str) {
        if (str.length) {
            let numb = str.replace(/\s/g, ""); // spaces
            numb = parseFloat(numb.replace(",", "."));
            numb = Math.round(numb * 100) / 100;
            return numb;
        }
        return 0;
    }

    async importFunction() {
        this.importLoading = true;
        this.cutDocument = undefined;
        // await this.computeCarryForward()
        this.importWizardDialog = true;
        this.importLoading = false;
    }

    aaNameFixedAssetStyle(item0) {
        if (!item0?.newAaNameFixedAsset || !item0?.newAaNameDepreciation) {
            return "color: red";
        }

        return "";
    }

    gapColorRed(gap) {
        if (!isAccountingZero(gap)) {
            return "color: primary";
        }
        return "";
    }

    @Watch("selectedFullGapsLines")
    sumSelectedGapsLines() {
        for (const obj of this.gapsStarts) {
            if (this.gaps?.[obj.group]?.sumGap) {
                this.sumSelectedGaps = 0;
                this.gapToAffect = this.gaps?.[obj.group]?.sumGap || 0;
                if (this.selectedFullGapsLines?.length) {
                    for (const x of this.selectedFullGapsLines) {
                        const line = this.gaps?.[obj.group].importLinesWithoutGl.find(
                            (l) => l.index === x,
                        );
                        this.sumSelectedGaps += line.alNetAmountSigned;
                    }
                }
                this.gapToAffect =
                    mathFix(this.gaps[obj.group]?.sumGap + this.sumSelectedGaps, 2) || 0;
            }
        }
    }

    selectedFullGapsLines: Array<any> = [];

    async generateNFixedAssets() {
        this.generateNDocumentsAndDepreciationsLoading = true;

        this.setActions(); // ** to refresh this.actions.action.loading = this.generateNDocumentsAndDepreciationsLoading

        this.notInFECDocuments = [];

        for (const w of this.selectedFullGapsLines) {
            let line: any = {};
            let accountingDate;
            const accountingLines = [];
            let wording = "";

            for (const key in this.gaps) {
                const obj = this.gapsStarts.find((gs) => gs.group === key);

                line = this.gaps[obj.group].importLinesWithoutGl.find((l) => l.index === w);
                accountingDate = getDBFormattedDate(
                    await getAccountingClosingDate(
                        this.$apollo,
                        this.companyId,
                        moment(line.date, "DD/MM/YYYY").format("YYYY-MM-DD"),
                    ),
                );
                wording = obj.wording + line.wording;

                if (key != "28" && key != "145") {
                    const al2 = {
                        date: accountingDate,
                        wording: wording,
                        amountSigned: line.alNetAmountSigned,
                        amount: Math.abs(line.alNetAmountSigned),
                        accountableAccount: await getAuditConnectAccountableAccount(
                            this.$store,
                            this.$apollo,
                            line.aaNameFixedAsset,
                        ),
                        company: { connect: { id: this.companyId } },
                        type: "ACCOUNTING",
                    };
                    accountingLines.push(al2);

                    const al404 = {
                        date: accountingDate,
                        wording: wording,
                        amountSigned: -line.alNetAmountSigned,
                        amount: Math.abs(line.alNetAmountSigned),
                        accountableAccount: await getAuditConnectAccountableAccount(
                            this.$store,
                            this.$apollo,
                            "404000",
                        ),
                        company: { connect: { id: this.companyId } },
                        type: "ACCOUNTING",
                    };
                    accountingLines.push(al404);
                } else {
                    const al28 = {
                        date: accountingDate,
                        wording: wording,
                        amountSigned: -line.previousDepreciationAmountSigned,
                        amount: Math.abs(line.previousDepreciationAmountSigned),
                        accountableAccount: await getAuditConnectAccountableAccount(
                            this.$store,
                            this.$apollo,
                            line.aaNameDepreciation,
                        ),
                        company: { connect: { id: this.companyId } },
                        type: "ACCOUNTING",
                    };
                    accountingLines.push(al28);

                    const aaName68 = line.aaNameDepreciation.startsWith("20")
                        ? await getAuditConnectAccountableAccount(
                              this.$store,
                              this.$apollo,
                              "681110",
                          )
                        : await getAuditConnectAccountableAccount(
                              this.$store,
                              this.$apollo,
                              "681120",
                          );
                    const al68 = {
                        date: accountingDate,
                        wording: wording,
                        amountSigned: line.previousDepreciationAmountSigned,
                        amount: Math.abs(line.previousDepreciationAmountSigned),
                        accountableAccount: aaName68,
                        company: { connect: { id: this.companyId } },
                        type: "ACCOUNTING",
                    };
                    accountingLines.push(al68);
                }
            }

            const testSum = mathFix(sumBy(accountingLines, "amountSigned"), 2);
            if (testSum !== 0) {
                console.error("testSum !== 0", testSum);
                debugger;
            }

            const document: any = getEmptyDocument(
                this.companyId,
                wording,
                "MISCELLANEOUS_OPERATION",
                accountingDate,
                this.currentUser.id,
                undefined,
                accountingLines,
                true,
            );
            this.notInFECDocuments.push(document);
        }

        let data: any = {};
        if (this.cutsACR?.data) {
            data = JSON.parse(JSON.stringify(this.cutsACR.data));
        }

        data.shortComment = this.shortComment || "";
        data.longComment = this.longComment || "";
        data.errorMessages = this.errorMessages || undefined;
        data.validated = false;
        data.notInFECDocuments = this.notInFECDocuments || undefined;

        const upsertVariables: any = {
            id: this.cutsACRId || "",
            key: this.commentsACRKey,
            companyId: this.companyId,
            status: this.validated ? "VALIDATED" : "EDITION",
            thirdPartyCompanyCreate: undefined,
            thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // documentCreateConnection: {connect: {id: this.invoice.id }},
            // documentUpdateConnection: {connect: {id: this.invoice.id}},
            deleteDocuments: [],
            documents: this.notInFECDocuments || undefined,
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            auditCheckKey: this.acKey,
            data: data || {},
            type: "IN_AUDIT_REPORT",
            reviewed: this.reviewed,
        };

        const generatednotInFECDocuments: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        if (generatednotInFECDocuments) {
            this.generateFullDepreciatedLoading = false;
            this.fullGapsDialog = false;
            this.gaps = {};
            await this.refresh();
        }
    }

    async generateNDepreciations() {
        this.generateFullDepreciatedLoading = true;

        this.setActions(); // ** to refresh this.actions.action.loading = this.generateNDocumentsAndDepreciationsLoading

        this.adjustDocumentsOnFullDepreciatedFixedAssets = [];

        for (const line of this.errorsOnFullDepreciatedFixedAssets) {
            // eslint-disable-next-line no-await-in-loop
            const accountingDate: string = getDBFormattedDate(
                await getAccountingClosingDate(
                    this.$apollo,
                    this.companyId,
                    moment(this.accountingPeriod?.start || "").format("YYYY-MM-DD"),
                ),
            );
            const accountingLines = [];
            const wording = "Régul écart immo/amos - " + line.wording;
            // eslint-disable-next-line no-await-in-loop
            const depreciation68 = line.aaName.startsWith("20")
                ? await getAuditConnectAccountableAccount(this.$store, this.$apollo, "681110")
                : await getAuditConnectAccountableAccount(this.$store, this.$apollo, "681120");

            const al68 = {
                date: accountingDate,
                wording: wording,
                amountSigned: -line.gap,
                amount: Math.abs(line.gap),
                accountableAccount: depreciation68,
                company: { connect: { id: this.companyId } },
                type: "ACCOUNTING",
            };
            accountingLines.push(al68);

            const al28 = {
                date: accountingDate,
                wording: wording,
                amountSigned: line.gap,
                amount: Math.abs(line.gap),
                accountableAccount: await getAuditConnectAccountableAccount(
                    this.$store,
                    this.$apollo,
                    line.aaDepreciationName,
                ),
                company: { connect: { id: this.companyId } },
                type: "ACCOUNTING",
            };
            accountingLines.push(al28);
            const testSum = mathFix(
                sumBy(accountingLines, "debit") + sumBy(accountingLines, "credit"),
                2,
            );
            if (testSum !== 0) {
                console.error("testSum !== 0", testSum);
                debugger;
            }

            const document: any = getEmptyDocument(
                this.companyId,
                wording,
                "MISCELLANEOUS_OPERATION",
                accountingDate,
                this.currentUser.id,
                undefined,
                accountingLines,
                true,
            );
            this.adjustDocumentsOnFullDepreciatedFixedAssets.push(document);
        }

        let data: any = {};
        if (this.cutsACR?.data) {
            data = JSON.parse(JSON.stringify(this.cutsACR.data));
        }

        data.shortComment = this.shortComment || "";
        data.longComment = this.longComment || "";
        data.errorMessages = this.errorMessages || undefined;
        data.validated = false;
        data.adjustDocumentsOnFullDepreciatedFixedAssets =
            this.adjustDocumentsOnFullDepreciatedFixedAssets || undefined;

        const upsertVariables: any = {
            id: this.cutsACRId || "",
            key: this.commentsACRKey,
            companyId: this.companyId,
            status: this.validated ? "VALIDATED" : "EDITION",
            thirdPartyCompanyCreate: undefined,
            thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // documentCreateConnection: {connect: {id: this.invoice.id }},
            // documentUpdateConnection: {connect: {id: this.invoice.id}},
            deleteDocuments: [],
            documents: this.adjustDocumentsOnFullDepreciatedFixedAssets || undefined,
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            auditCheckKey: this.acKey,
            data: data || {},
            type: "IN_AUDIT_REPORT",
            reviewed: this.reviewed,
        };

        const generatedDocuments: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        if (generatedDocuments) {
            this.errorsOnFullDepreciatedFixedAssets = [];
            this.generateFullDepreciatedLoading = false;
            this.fullDepreciatedFixedAssetsDialog = false;
            await this.refresh();
        }
    }

    showGenerateDocumentsNBtn() {
        if (
            this.gapToAffect &&
            (this.closedPeriod || this.loading || this.dataLoading || !this.accountingPeriod)
        ) {
            return false;
        }
        return true;
    }

    get showUpdatedLinearSpreadStartDateBtn() {
        if (this.gap68LOnRegulN_1Errors?.length) {
            let errorsCount = 0;
            for (const gap68OnRegulN_1Error of this.gap68LOnRegulN_1Errors) {
                // ** 3 variables: suggestedDate, (buy) date and linearSpreadStartDate
                // ** linearSpreadStartDate is in date-picker and, originally set to date
                if (
                    gap68OnRegulN_1Error.suggestedDate &&
                    gap68OnRegulN_1Error.currentAlAcrData.linearSpreadStartDate
                ) {
                    const linearSpreadStartDate = moment(
                        gap68OnRegulN_1Error.currentAlAcrData?.linearSpreadStartDate,
                    ).format("YYYY-MM-DD");
                    const suggestedDatePlus7 = moment(
                        gap68OnRegulN_1Error.suggestedDate,
                        "YYYY/MM/DD",
                    )
                        .add(7, "days")
                        .format("YYYY-MM-DD");

                    const suggestedDateMinus7 = moment(
                        gap68OnRegulN_1Error.suggestedDate,
                        "YYYY/MM/DD",
                    )
                        .add(-7, "days")
                        .format("YYYY-MM-DD");

                    if (
                        linearSpreadStartDate <= suggestedDatePlus7 &&
                        linearSpreadStartDate >= suggestedDateMinus7
                    ) {
                        errorsCount++;
                    }
                }
            }
            if (errorsCount === this.gap68LOnRegulN_1Errors.length) {
                return true;
            }
        }
        return false;
    }

    async updateLinearSpreadStartDate() {
        if (
            this.showUpdatedLinearSpreadStartDateBtn &&
            this.gap68LOnRegulN_1Errors.length &&
            this.fixedAssetsFile?.length
        ) {
            for (const gap68OnRegulN_1Error of this.gap68LOnRegulN_1Errors) {
                const currentFixedAsset =
                    this.fixedAssetsFile[gap68OnRegulN_1Error.originalFixedAssetsFileIndex];
                // ** currentFixedAsset.linearSpreadStartDate is old value
                // ** gap68OnRegulN_1Error.currentAlAcrData.linearSpreadStartDate is new value
                currentFixedAsset.linearSpreadStartDate = moment(
                    gap68OnRegulN_1Error.currentAlAcrData.linearSpreadStartDate,
                ).format("DD/MM/YYYY");
                
                // if (currentFixedAsset.type === 'D') {
                //     console.log("🚀 - updateLinearSpreadStartDate - currentFixedAsset.linearSpreadStartDate:", currentFixedAsset.linearSpreadStartDate)
                //     currentFixedAsset.decliningSpreadStartDate = moment(currentFixedAsset.linearSpreadStartDate, "DD/MM/YYYY").startOf("month").format("DD/MM/YYYY")
                //     console.log("🚀 - updateLinearSpreadStartDate - currentFixedAsset.decliningSpreadStartDate:", currentFixedAsset.decliningSpreadStartDate)
                // }
            }

            const upsertVariables: any = {
                id: this.cutsACRId || "",
                key: this.commentsACRKey,
                companyId: this.companyId,
                status: this.validated ? "VALIDATED" : "EDITION",
                thirdPartyCompanyCreate: undefined,
                thirdPartyCompanyUpdate: undefined,
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                // documentCreateConnection: {connect: {id: this.invoice.id }},
                // documentUpdateConnection: {connect: {id: this.invoice.id}},
                // ******************************
                // ** delete only "normal" cut result
                // ** keep notInFECDocuments results
                deleteDocuments: [],
                // *******************************
                // documents: this.cutDocument && !isEmpty(this.cutDocument) ? [this.cutDocument] : [],
                documents: undefined,
                auditCheckKey: this.acKey,
                data: this.cutsACR.data || {},
                type: "IN_AUDIT_REPORT",
            };

            const storedCuts: any = await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT,
                variables: upsertVariables,
            });

            if (storedCuts) {
                this.gap68LOnRegulN_1ErrorsDialog = false;
                this.gap68LOnRegulN_1Errors.length -= 1;
                this.refresh();
            }
        }
    }

    changeNoGapFixedAssetAccountableAccounts(scope) {
        const gapAccountableAccount =
            scope === "fixedAssets"
                ? this.gap_fixedAssetsAccountableAccount
                : this.gap_depreciationAccountableAccount;
        const importLinesWithoutGlAmount =
            scope === "fixedAssets" ? "alNetAmountSigned" : "previousDepreciationAmountSigned";
        const importLinesWithoutGlAccountableAccount =
            scope === "fixedAssets" ? "aaNameFixedAsset" : "aaNameDepreciation";
        const changedSums = [];

        for (const line of gapAccountableAccount.gapData.importLinesWithoutGl) {
            if (line.changedAccountableAccount === "Inchangé") {
                line.changedAccountableAccount = line[importLinesWithoutGlAccountableAccount];
            }

            if (line.changedAccountableAccount !== line[importLinesWithoutGlAccountableAccount]) {
                const originalAaToChange = changedSums.find(
                    (a) =>
                        gapAccountableAccount.gapData.toProposeGlAccountableAccounts.includes(
                            line[importLinesWithoutGlAccountableAccount],
                        ) && a.accountableAccount === line[importLinesWithoutGlAccountableAccount],
                );
                if (!originalAaToChange) {
                    changedSums.push({
                        accountableAccount: line[importLinesWithoutGlAccountableAccount],
                        sum: -line[importLinesWithoutGlAmount],
                    });
                } else {
                    originalAaToChange.sum -= line[importLinesWithoutGlAmount];
                }
                const changedAA = changedSums.find(
                    (a) => a.accountableAccount === line.changedAccountableAccount,
                );
                if (!changedAA) {
                    changedSums.push({
                        accountableAccount: line.changedAccountableAccount,
                        sum: line[importLinesWithoutGlAmount],
                    });
                } else {
                    changedAA.sum += line[importLinesWithoutGlAmount];
                }
            }
        }

        for (const aa of gapAccountableAccount.gapData.glWithoutImportResume) {
            const changedImportedAA = changedSums.find((a) => a.accountableAccount === aa.aaName);
            if (changedImportedAA) {
                aa.importedSum = changedImportedAA.sum;
            } else {
                aa.importedSum = 0;
            }
            aa.gap = mathFix(aa.glSum - aa.alreadyImportedSum - aa.importedSum, 2);
        }

        const someSumGapsNotNull = gapAccountableAccount.gapData.glWithoutImportResume.some(
            (a) => a.gap,
        );
        if (someSumGapsNotNull) {
            this.disabledChangeFixedAssetsAccountableAccountGap = true;
        } else {
            this.disabledChangeFixedAssetsAccountableAccountGap = false;
        }
    }

    async storeAccountableAccountsChanges() {
        if (this.gap_fixedAssetsAccountableAccount?.gapData?.importLinesWithoutGl?.length) {
            for (const line of this.gap_fixedAssetsAccountableAccount.gapData
                .importLinesWithoutGl) {
                const foundedFAF = this.fixedAssetsFile.find(
                    (f) =>
                        f.date === line.date &&
                        f.rate === line.rate &&
                        f.type === line.type &&
                        f.wording === line.wording &&
                        f.aaNameFixedAsset === line.aaNameFixedAsset &&
                        f.alNetAmountSigned === line.alNetAmountSigned &&
                        f.aaNameDepreciation === line.aaNameDepreciation &&
                        f.previousDepreciationAmountSigned ===
                            line.previousDepreciationAmountSigned,
                );
                if (foundedFAF && foundedFAF.aaNameFixedAsset !== line.changedAccountableAccount) {
                    foundedFAF.aaNameFixedAsset = line.changedAccountableAccount;
                }
            }
        } else if (this.gap_depreciationAccountableAccount?.gapData?.importLinesWithoutGl?.length) {
            for (const line of this.gap_depreciationAccountableAccount.gapData
                .importLinesWithoutGl) {
                const foundedFAF = this.fixedAssetsFile.find(
                    (f) =>
                        f.date === line.date &&
                        f.rate === line.rate &&
                        f.type === line.type &&
                        f.wording === line.wording &&
                        f.aaNameFixedAsset === line.aaNameFixedAsset &&
                        f.alNetAmountSigned === line.alNetAmountSigned &&
                        f.aaNameDepreciation === line.aaNameDepreciation &&
                        f.previousDepreciationAmountSigned ===
                            line.previousDepreciationAmountSigned,
                );
                if (
                    foundedFAF &&
                    foundedFAF.aaNameDepreciation !== line.changedAccountableAccount
                ) {
                    foundedFAF.aaNameDepreciation = line.changedAccountableAccount;
                }
            }
        } else if (this.gap_derogationAccountableAccount?.gapData?.importLinesWithoutGl?.length) {
            for (const line of this.gap_derogationAccountableAccount.gapData.importLinesWithoutGl) {
                const foundedFAF = this.fixedAssetsFile.find(
                    (f) =>
                        f.date === line.date &&
                        f.rate === line.rate &&
                        f.type === line.type &&
                        f.wording === line.wording &&
                        f.aaNameFixedAsset === line.aaNameFixedAsset &&
                        f.alNetAmountSigned === line.alNetAmountSigned &&
                        f.aaNameDepreciation === line.aaNameDepreciation &&
                        f.previousDepreciationAmountSigned ===
                            line.previousDepreciationAmountSigned,
                );
                if (foundedFAF) {
                    console.error(
                        "TODO: change aaNameDepreciation to derogation (column not yet imported)",
                    );
                    debugger;
                    // foundedFAF.aaNameDepreciation = line.changedAccountableAccount
                }
            }
        }

        this.cutsACR.data.fixedAssetsFile = this.fixedAssetsFile;

        const upsertVariables: any = {
            id: this.cutsACRId || "",
            key: this.commentsACRKey,
            companyId: this.companyId,
            status: this.validated ? "VALIDATED" : "EDITION",
            thirdPartyCompanyCreate: undefined,
            thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // documentCreateConnection: {connect: {id: this.invoice.id }},
            // documentUpdateConnection: {connect: {id: this.invoice.id}},
            // ******************************
            // ** delete only "normal" cut result
            // ** keep notInFECDocuments results
            deleteDocuments: [],
            // *******************************
            // documents: this.cutDocument && !isEmpty(this.cutDocument) ? [this.cutDocument] : [],
            documents: undefined,
            auditCheckKey: this.acKey,
            data: this.cutsACR.data || {},
            type: "IN_AUDIT_REPORT",
        };

        const changedAccountableAccounts: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        // ** stored changes
        if (changedAccountableAccounts) {
            this.refresh();
            this.changeAccountableAccountsGapsDialog = false;
        }
    }

    glGapColor(gap) {
        if (gap) {
            return "text-primary";
        }
        return "";
    }

    gapSelectColor(item, column) {
        if (!item.changedAccountableAccount) {
            return "font-weight: bold";
        }
        if (item.changedAccountableAccount && item.changedAccountableAccount !== item[column]) {
            return "font-weight: bold; color: #F9B73B";
        }
        return "font-weight: bold; color: grey";
    }

    sumColumn(data, column) {
        // return data.reduce((acc, val) => acc + val[column], 0)
        const sum = sumBy(data, column);
        return sum;
    }

    get disabledStoreCutDocument() {
        if (this.cutDocument?.accountingLines?.create?.length) {
            const alsSum = mathFix(
                sumBy(this.cutDocument.accountingLines.create, "amountSigned"),
                2,
            );
            if (!alsSum) {
                return false;
            }
        }
        return true;
    }

    get getIncompleteFECStep() {
        // [
        //     'default',
        //     'alert',
        //     'fullDepreciatedFixedAssets',
        //     'glWithoutImportResume',
        //     'accountableAccountsList'
        // ]
        if (
            this.gaps?.["2"]?.sumGap &&
            this.gap_fixedAssetsAccountableAccount?.gapData?.glWithoutImportResume?.length
        ) {
            return "glWithoutImportResume";
        }

        return "accountableAccountsList";
    }
}

export default toNative(CheckFixedAssetsCutPrevious);
</script>
